/**
 * Extends the widgets data model with custom properties
 * @module stateExtension
 */
import React, { Component } from "react";
import { parsePersonalizzaWidgets } from './actions/componentsActions'

/**
 * The input fields validation patterns
 * @private
 * @type {Object}
 */
export const VALIDATION_PATTERNS = {
  mobilePrefix: /^[+-]?[0-9]+$/,
  mobileNumber: /^[0-9]{9,10}$/,
  number: /^[0-9]+$/,
  alphabetic: /^[a-zA-Z \']+$/,
  alphanumeric: /^[a-zA-Z0-9 \']+$/,
  address: /^([a-zA-Z0-9\',\.\/\\\-]+\s){2,}(\d+|snc)[a-zA-Z0-9\',\.\/\\\-\s]*$/,
  date: /^(3[01]|[12][0-9]|0[1-9])\/(1[0-2]|0[1-9])\/[0-9]{4}$/,
  cf: /^[A-Za-z]{6}\d{2}[A-Za-z]\d{2}[A-Za-z]\w{3}[A-Za-z]$/,
  cap: /^[0-9]{5}$/,
  otp: /^[a-zA-Z0-9 \']{6}$/,
  otpEmail: /^[a-zA-Z0-9 \']{8}$/,
  city: /^[a-zA-Z\u0080-\u024F\s'\.\-]+$/,
  email: /^[-a-z0-9~!$%^&*_=}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9][-a-z0-9]*(\.[-a-z0-9]+)*\.(aero|arpa|biz|com|coop|edu|email|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i,
  bool: /^selected$/,
  filled: /^.+/,
  decimal:/^\d*\.?\d*$/
}

export const VALIDATION_METHODS = {
  mobilePrefix: c => VALIDATION_PATTERNS.mobilePrefix.test(c.value),
  mobileNumber: c => VALIDATION_PATTERNS.mobileNumber.test(c.value),
  alphabetic: c => VALIDATION_PATTERNS.alphabetic.test(c.value),
  alphanumeric: c => VALIDATION_PATTERNS.alphanumeric.test(c.value),
  address: c =>
    VALIDATION_PATTERNS.address.test(c.value) &&
    c.value.length <= LENGTH_CONSTRAINTS.address,
  date: c => VALIDATION_PATTERNS.date.test(c.value),
  cf: c => VALIDATION_PATTERNS.cf.test(c.value),
  cfUnderage: c =>
    c.errorMessage.indexOf(
      "Questo prodotto puo' essere richiesto solo da maggiorenni o minorenni tra 12 e 18 anni"
    ) < 0,
  cap: c => VALIDATION_PATTERNS.cap.test(c.value),
  otp: c => VALIDATION_PATTERNS.otp.test(c.value),
  otpEmail: c => VALIDATION_PATTERNS.otpEmail.test(c.value),
  city: c => VALIDATION_PATTERNS.city.test(c.value),
  email: c => VALIDATION_PATTERNS.email.test(c.value),
  bool: c => VALIDATION_PATTERNS.bool.test(c.value),
  filled: c => VALIDATION_PATTERNS.filled.test(c.value),
  number: c => VALIDATION_PATTERNS.number.test(c.value),
  decimal: c => VALIDATION_PATTERNS.decimal.test(c.value),
  underageContactConflict: c => {
    return !(
      c.errorMessage.find(e => e === 'Campo non valido') &&
      !!c.validations &&
      !!c.validations.default &&
      c.validations.default.reduce((res, rule) => res && rule.validate(c), true)
    )
  }
}

const TITOLARE_EFFETTIVO_WIDGETS = [
  'TITOLARE_ESERCITA',
  'TITOLARE_ESERCITA-LABEL',
  'TITOLARE_ESERCITA-ESERCITA_SI',
  'TITOLARE_ESERCITA-ESERCITA_NO',
  'RESIDENZA',
  'RESIDENZA-FISCALE',
  'RESIDENZA-NAZIONE',
  'RESIDENZA-CAP',
  'RESIDENZA-PROVINCIA',
  'RESIDENZA-CITTA',
  'RESIDENZA-INDIRIZZO',
  'DOCUMENTO',
  'DOCUMENTO-DATA_RILASCIO',
  'DOCUMENTO-DATA_SCADENZA',
  'DOCUMENTO-DOCF_UPLOAD',
  'DOCUMENTO-DOCR_UPLOAD',
  'DOCUMENTO-ENTE_RILASCIO',
  'DOCUMENTO-LUOGO_RILASCIO',
  'DOCUMENTO-NUMERO_DOCUMENTO',
  'DOCUMENTO-TIPO_DOCUMENTO',
  'NOME_COGNOME',
  'NOME_COGNOME-COGNOME',
  'NOME_COGNOME-NOME',
  'CODICE_FISCALE',
  'CODICE_FISCALE-CF',
  'SZ0025'
]
const TITOLARE_EFFETTIVO_QUESTIONS=
[
 'SZ0025-SS0052_DM0097',
 'SZ0025-SS0052_DM0097_RI0022',
 'SZ0025-SS0052_DM0097_RI0023',
 'SZ0025-SS0163_DM0503',
 'SZ0025-SS0163_DM0503_RI0568',
 'SZ0025-SS0163_DM0503_RI0569',
 'TITOLARE_OWNER-LABEL',
 'TITOLARE_OWNER-EFFETTIVO_NO',
 'TITOLARE_OWNER-EFFETTIVO_SI'
]
export const Titolare_Effectivo_EmptyJSONResponse=[
  {
     "name":"TITOLARE_EFFETTIVO_DATA",
     "rawValue":{
        "titolare_effettivo":[
           {
              "id":1,
              "datiContatto":{
                 "nome":"",
                 "cognome":"",
                 "codiceFiscale":"",
                 "luogoDiNascita":"",
                 "sesso":"",
                 "provinciaDiNascita":"",
                 "dataDiNascita":""
              },
              "residenza":{
                 "cap":"",
                 "provincia":"",
                 "citta":"",
                 "nazione":"ITALIA",
                 "indirizzo":"",
                 "residenzaFiscale":"ITALIA"
              },
              "documento":{
                 "tipo_documento":"-",
                 "ente_rilascio":"Comune",
                 "luogo_rilascio":"",
                 "numero_documento":"",
                 "data_rilascio":"",
                 "data_scadenza":""
              },
              "domicilio":{
                 
              },
              "directPepDetail":{
                 
              },
              "indirectPepDetail":{
                 
              }
           }
        ]
     }
  }
]

const LENGTH_CONSTRAINTS = {
  address: 40
}

export const VALIDATION_ERRORS = {
  filled: c => {
    if (
      c.value.trim().length < 1 &&
      c.validations &&
      c.validations.isRequired
    ) {
      return (c.cleanName && `${c.cleanName} è obbligatorio`) || ''
    } else {
      return (c.cleanName && `${c.cleanName} non è valido`) || ''
    }
  },
  address: c => {
    let errorMessage
    if (
      c.value.trim().length < 1 &&
      c.validations &&
      c.validations.isRequired
    ) {
      errorMessage = `${c.cleanName} sono obbligatori`
    } else if (c.value.trim().length > LENGTH_CONSTRAINTS.address) {
      errorMessage = `${c.cleanName} superano i ${
        LENGTH_CONSTRAINTS.address
        } caratteri consentiti`
    } else {
      // errorMessage = `${c.cleanName} non sono completi`
      errorMessage =
        'Attenzione, indirizzo incompleto. Ricordati di indicare il qualificatore (Via, Piazza, C.so, etc.), il nome della via e il numero civico (se non è presente il civico, inserisci SNC)'
      if (/[^a-zA-Z0-9\',\.\/\\\-\s]+/.test(c.value.trim())) {
        errorMessage = `${c.cleanName} non sono validi`
      }
    }
    return errorMessage
  },
  underageContactConflict: c => {
    const isEmail = c.name === 'EMAIL'
    return `Quest${isEmail ? 'a' : 'o'} è ${isEmail ? 'la' : 'il'} tu${
      isEmail ? 'a' : 'o'
      } ${c.cleanName}, inserisci quell${isEmail ? 'a' : 'o'} del genitore`
  },
  cfUnderage: (/*c*/) =>
    'Puoi richiedere il prodotto solo se hai compiuto almeno 12 anni'
}

/**
 * The input fields hints
 * @private
 * @type {Object}
 */
const HINTS = {
  address:
    'Inserisci anche il C/O (presso) se sulla cassetta delle lettere non è presente il tuo cognome'
}

/**
 * Exports the extended widget model
 * @public
 * @see {@link https://github.com/hype-app/hype-onboarding-react/tree/master/app/state/stateExtension.js stateExtension.js}
 */
export const WIDGETS = {
  FLOW_BAR: {
    group: 'FLOW_BAR',
    groupTitle: 'Progresso'
  },
  ADESIONE_CONSULENZA: {
    group: 'ADESIONE_CONSULENZA',
    groupTitle: 'Adesione consulenza'
  },
  ANTIRICICLAGGIO: {
    group: 'ANTIRICICLAGGIO',
    groupTitle: ''
  },
  ATTIVA_REVOCA_FIRMA: {
    group: 'ATTIVA_REVOCA_FIRMA',
    groupTitle: 'Attiva o revoca la firma digitale',
    status: []
  },
  BONIFICO: {
    group: 'MOD_IDENTIFICAZIONE',
    groupTitle: 'Fatti riconoscere'
  },
  BUNDLE: {
    group: 'BUNDLE',
    groupTitle: 'Bundle prodotti'
  },
  CAT_IDENTIFICAZIONE: {
    group: 'CAT_IDENTIFICAZIONE',
    groupTitle: 'Categoria identificazione'
  },
  CELLULARE: {
    group: 'CONTATTI',
    groupTitle: 'Contatti'
  },
  CHI_CONSIGLIA: {
    group: 'CHI_CONSIGLIA',
    groupTitle: 'Consigliano Hype'
  },
  CITTADINANZA: {
    group: 'CITTADINANZA',
    groupTitle: 'Cittadinanza'
  },
  DENOMINAZIONE_AZIENDA: {
    group: 'DENOMINAZIONE_AZIENDA',
    groupTitle: 'Ragione Sociale'
  },
  AZIENDA_TYPE: {
    group: 'AZIENDA_TYPE',
    groupTitle: 'Forma Giuridica'
  },
  AZIENDA_SUBTYPE: {
    group: 'AZIENDA_TYPE',
    groupTitle: 'Forma Giuridica'
  },
  CODICE_FISCALE: {
    group: 'IDENTITA',
    groupTitle: 'Identità',
    quiet: true
  },
  CODICE_PROMOZIONALE: {
    group: 'CODICE_PROMOZIONALE',
    groupTitle: 'Hai un codice promo?'
  },
  CONTO_ADDEBITO: {
    group: 'INFO_CONTO',
    groupTitle: 'Informazioni conto'
  },
  CONTO_RIFERIMENTO: {
    group: 'INFO_CONTO',
    groupTitle: 'Informazioni conto'
  },
  CRONISTORIA: {
    group: 'CRONISTORIA',
    groupTitle: 'Cronistoria'
    //status: ['hidden']
  },
  DATI_SENSIBILI: {
    group: 'DATI_SENSIBILI',
    groupTitle: 'Privacy'
  },
  DOCUMENTAZIONE: {
    group: 'DOCUMENTAZIONE',
    groupTitle: 'Documentazione',
    status: ['hidden']
  },
  DOCUMENTO: {
    group: 'DOCUMENTO',
    groupTitle: 'Documento di identificazione del richiedente o del legale rappresentante'
    // quiet: true
  },
  DOCUMENTO_2: {
    group: 'DOCUMENTO_2',
    groupTitle: 'Documento intestato al richiedente o al legale rappresentante per verifica della residenza'
    // quiet: true
  },
  //Changes for loading new widget
  DOCUMENTO_GENERICO :
  {
    group:'DOCUMENTO_GENERICO',
    groupTitle: 'CERTIFICATO DI ATTRIBUZIONE PARTITA IVA'
  },
  DOMICILIO: {
    group: 'DOMICILIO',
    groupTitle: 'Domicilio'
  },
  DIFARMA_0: {
    group: 'DIFARMA_0'
  },
  DIFARMA_1: {
    group: 'DIFARMA_1'
  },
  DIFARMA_2: {
    group: 'DIFARMA_2'
  },
  DIFARMA_3: {
    group: 'DIFARMA_3'
  },
  DIFARMA_4: {
    group: 'DIFARMA_4'
  },
  EMAIL: {
    group: 'CONTATTI',
    groupTitle: 'Contatti'
  },
  /* FIRMA: {
    group: 'FIRMA',
    groupTitle: 'Firma'
  }, */
  INTERESSI_CC: {
    group: 'CONTO',
    groupTitle: 'Conto'
  },
  INTESTATARI_FISSI: {},
  INVITO_INTESTATARI: {
    group: 'INVITO_INTESTATARI',
    groupTitle: 'Genitore o tutore',
    quiet: true
  },
  LABEL: {},
  MOD_IDENTIFICAZIONE: {
    group: 'MOD_IDENTIFICAZIONE',
    groupTitle: 'Fatti riconoscere',
    status: ['hidden']
  },
  NOME_COGNOME: {
    group: 'IDENTITA',
    groupTitle: 'Identità'
  },
  NUMERO_INTESTATARI: {
    group: 'NUMERO_INTESTATARI',
    groupTitle: 'Numero di intestatari'
  },
  PRIVACY: {
    group: 'PRIVACY',
    groupTitle: 'Privacy'
  },
  PROFESSIONE_ATTIVITA: {
    group: 'ATTIVITA',
    groupTitle: 'Attività'
  },
  PROFILAZIONE: {
    group: 'PROFILAZIONE',
    groupTitle: 'Profilazione'
    //status: ['hidden']
  },
  PROMOZIONE: {
    group: 'PROMOZIONE',
    groupTitle: 'Promozioni'
    //status: []
  },
  PROMOZIONE_TERZI: {
    group: 'PROMOZIONE_TERZI',
    groupTitle: 'Promozione Terzi'
    //status: ['hidden']
  },
  RESIDENZA: {
    group: 'RESIDENZA',
    groupTitle: 'Residenza'
  },
  RESIDENZA_FISCALE: {
    group: 'RESIDENZA_FISCALE',
    groupTitle: 'Residenza Fiscale'
  },
  RESUME_BY_CELL: {
    group: 'RESUME_BY_CELL',
    groupTitle: 'Riprendi usando il numero di cellulare'
  },
  RIF_POSTALE: {
    group: 'RIF_POSTALE',
    groupTitle: 'Riferimento postale'
  },
  RIF_SPEDIZIONE_CARTA: {
    group: 'RIF_SPEDIZIONE_CARTA',
    groupTitle: 'Dove vuoi ricevere la tua carta?'
  },
  SELFIE: {
    group: 'MOD_IDENTIFICAZIONE',
    groupTitle: 'Fatti riconoscere'
  },
  SUCCURSALE: {
    group: 'SUCCURSALE',
    groupTitle: 'Succursale'
  },
  SUCCURSALE_IDENTIFICAZIONE: {
    group: 'SUCCURSALE_IDENTIFICAZIONE',
    groupTitle: 'Identificazione succursale'
  },
  /*  TERMINA_PROCEDURA: {
     group: 'TERMINA_PROCEDURA',
     groupTitle: 'Concludi la registrazione'
   }, */
  TIPOLOGIA_CARTA: {
    group: 'TIPOLOGIA_CARTA',
    groupTitle: 'Scegli il tipo di carta'
  },
  VERIFICA_DATI_DA_CF: {
    group: 'VERIFICA_DATI_DA_CF',
    groupTitle: 'Verifica dati',
    quiet: true
  },
  WIDGET_HTML: {
    group: 'WIDGET_HTML',
    groupTitle: 'Widget HTML'
  },
  JOLLY: {
    group: 'JOLLY',
    groupTitle: 'Autorizzazione a procedere'
  },
  LOGIN_SE_CLIENTE: {
    group: 'LOGIN_SE_CLIENTE',
    groupTitle: ''
  },
  ATTESA: {},
  VISIONE_CONTRATTI: {},
  SIGNALER: {
    bundleCode: null,
    bundleLink: null,
    code: '999',
    components: [],
    errorMessage: [],
    group: 'SIGNALER',
    groupTitle: 'Hai un codice promo?',
    name: 'SIGNALER',
    position: 9,
    status: [],
    extra: true
  },
  WHAT_YOU_NEED: {
    bundleCode: null,
    bundleLink: null,
    code: '998',
    components: [],
    errorMessage: [],
    group: 'WHAT_YOU_NEED',
    groupTitle: 'Cosa ti serve sapere',
    name: 'WHAT_YOU_NEED',
    position: 0,
    status: [],
    extra: true
  },
  VERIFICA_EMAIL_EXTRA: {
    bundleCode: null,
    bundleLink: null,
    code: '998',
    components: [],
    errorMessage: [],
    group: 'VERIFICA_EMAIL_EXTRA',
    groupTitle: 'Verifica email',
    name: 'VERIFICA_EMAIL_EXTRA',
    position: 0,
    status: ['hidden'],
    extra: true
  },
  PARTITA_IVA: {
    group: 'RIFERIMENTI_FISCALI',
    groupTitle: 'Riferimenti Fiscali'
  },
  CF_AZIENDA: {
    group: 'RIFERIMENTI_FISCALI',
    groupTitle: 'Riferimenti Fiscali'
  },
  AZIENDA_ROLES: {
    group: 'AZIENDA_ROLES',
    groupTitle: 'Indica la carica o il ruolo che rivesti in azienda'
  },
  CLASSIFICAZIONE_AZIENDA: {
    group: 'CLASSIFICAZIONE_AZIENDA',
    groupTitle: 'INFORMAZIONI PER LA CLASSIFICAZIONE DELLA AZIENDA'
  },
  PEC: {
    group: 'INFO_AZIENDA',
    groupTitle: 'INFO AZIENDA'
  },
  TELEFONO_FISSO: {
    group: 'INFO_AZIENDA',
    groupTitle: 'INFO AZIENDA'
  },
  SEDE_LEGALE: {
    group: 'SEDE_LEGALE',
    groupTitle: 'SEDE LEGALE'
  },
  SEDE_AMMINISTRATIVA: {
    group: 'SEDE_AMMINISTRATIVA',
    groupTitle: 'SEDE AMMINISTRATIVA'
  },
  //step 4:
  SETTORE_ATTIVITA_AZIENDA: {
    group: 'SETTORE_ATTIVITA_AZIENDA',
    groupTitle: 'SETTORE E ATTIVITÀ ECONOMICA'
  },
  AZIENDA_ANTIRICICLAGGIO: {
    group: 'AZIENDA_ANTIRICICLAGGIO',
    groupTitle: ''
  },
  //step 5:
  TITOLARE_DATA: {
    group: 'TITOLARE_DATA',
    groupTitle: 'TITOLARE EFFETTIVO'
  },
  TITOLARE_OWNER: {
    group: 'TITOLARE_OWNER',
    groupTitle: ''
  },
  TITOLARE_ESERCITA: {
    group: 'TITOLARE_ESERCITA',
    groupTitle: ''
  },
  //step 6:
  PRODUCT_PLUGIN: {
    group: 'PRODUCT_PLUGIN',
    groupTitle: 'PUNTO VENDITA',
    status: ['hidden']
  },

  TITOLARE_EFFETTIVO: {
    group: 'TITOLARE EFFETTIVO',
    groupTitle: 'TITOLARE EFFETTIVO',
    status: ['hidden']
  },

  FORMA_GIURIDIA: {
    code: '27232',
    name: 'FORMA_GIURIDIA',
    bundleCode: null,
    bundleLink: null,  
    errorMessage: [],
    group: 'AZIENDA_TYPE',
    status: [],
    extra: true
    
  },
 
  SETTORE_ATTIVITA_AZIENDA_COMP: {
    code: '27232',
    name: 'SETTORE_ATTIVITA_AZIENDA_COMP',
    bundleCode: null,
    bundleLink: null,  
    components: [
      {
        name: 'SETTORE_ATTIVITA_AZIENDA_COMP_DESC',
        value: `per <b>attività finanziarie</b> si intendono attività di assicurazione, concessione di finanziamenti, crediti e microcrediti, crediti a consumo ed ipotecari, l’emissione o gestione di carte di credito, di debito o di altri mezzi di pagamento, etc`,
        rawValue: null,
        status: [],
        position:1,
        errorMessage: [],
        validations: [],
        values: [],
        type: 'label',
        isSmall:true,
        active:true
      }],
    errorMessage: [],
    status: [],
    extra: true
  }
}

/**
 * Exports the extended components model
 * @public
 * @see {@link https://github.com/hype-app/hype-onboarding-react/tree/master/app/state/stateExtension.js stateExtension.js}
 */
export const COMPONENTS = {
  'FLOW_BAR-STEP_1': {
    name: 'STEP_1',
    type: null,
    cleanName: 'Inizio'
    /*,
          value: 'La carta che gestisci e controlli con l\'app!'*/
  },
  'FLOW_BAR-STEP_2': {
    name: 'STEP_2',
    type: null,
    cleanName: 'Secondo step'
  },
  'FLOW_BAR-STEP_3': {
    name: 'STEP_3',
    type: null,
    cleanName: 'Terzo step'
  },
  'FLOW_BAR-STEP_4': {
    name: 'STEP_4',
    type: null,
    cleanName: 'Quarto step'
  },
  'FLOW_BAR-STEP_5': {
    name: 'STEP_5',
    type: null,
    cleanName: 'Quinto step'
  },
  'ADESIONE_CONSULENZA-ADESIONE_SI': {
    name: 'ADESIONE_SI',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    cleanName: 'Adesione SÌ'
  },
  'ADESIONE_CONSULENZA-ADESIONE_NO': {
    name: 'ADESIONE_SI',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    cleanName: 'Adesione NO'
  },
  'ANTIRICICLAGGIO-QUESTIONARIO': {
    name: 'QUESTIONARIO',
    cleanName: 'Questionario'
  },
  'ATTIVA_REVOCA_FIRMA-LINK_ISTRUZIONI': {
    id: 'ATTIVA_REVOCA_FIRMA-LINK_ISTRUZIONI',
    name: 'LINK_ISTRUZIONI',
    type: 'labelWithLink',
    status: [],
    link: {
      placeholder: '§link§',
      text: 'Istruzioni operative',
      url:
        'http://www.trusttechnologies.it/document_loader.aspx?idDocument=150',
      target: '_blank'
    },
    value: 'e delle §link§',
    extra: true,
    position: 3,
    element: 'span'
  },
  'ATTIVA_REVOCA_FIRMA-LINK_ADDENDUM': {
    id: 'ATTIVA_REVOCA_FIRMA-LINK_ADDENDUM',
    name: 'LINK_ADDENDUM',
    type: 'labelWithLink',
    status: [],
    link: {
      placeholder: '§link§',
      text: `dell'Addendum al manuale operativo`,
      url: 'http://www.trusttechnologies.it/document_loader.aspx?idDocument=58',
      target: '_blank'
    },
    value: '§link§',
    extra: true,
    position: 2,
    element: 'span'
  },
  'ATTIVA_REVOCA_FIRMA-LINK_MANUALE': {
    id: 'ATTIVA_REVOCA_FIRMA-LINK_MANUALE',
    name: 'LINK_MANUALE',
    type: 'labelWithLink',
    status: [],
    link: {
      placeholder: '§link§',
      text: `Manuale operativo.`,
      url:
        'https://www.sella.it/SSRDocumentDisplayer?dtdPG=IS_OP_SELLADIGIT_PIN_SMS&dtdPE=1',
      target: '_blank'
    },
    value: `La firma digitale è un servizio gratuito che ti consente di firmare i documenti comodamente online, senza stampare.Per Proseguire nell' attivazione prendi visione del §link§`,
    extra: true,
    position: 1,
    element: 'span'
  },
  'ATTIVA_REVOCA_FIRMA-FIRMA': {
    name: 'FIRMA',
    cleanName: 'ATTIVA',
    type: 'sella',
    pullTo: 'right',
    position: 4,
    status: [],
    action: {
      value: 'Attivata',
      type: 'inverse',
      disabled: true,
      fetch: {
        attivata: {
          url: 'wgt/sign/active',
          body: {},
          mappingEvent: 'IframeSrcSetter'
        }
      },
      updateComponentId: 'ATTIVA_REVOCA_FIRMA-IFRAME',
      toggleVisibility: {
        show: {
          fields: ['ATTIVA_REVOCA_FIRMA-IFRAME']
        }
      }
    }
  },
  'ATTIVA_REVOCA_FIRMA-IFRAME': {
    name: 'IFRAME',
    cleanName: 'iFrame',
    value: '',
    otpMessage: true
  },
  'ATTIVA_REVOCA_FIRMA-MODAL': {
    name: 'Modal',
    value: '',
    title: 'Messaggio'
  },
  'ATTIVA_REVOCA_FIRMA-VISIONE': {
    name: 'VISIONE',
    cleanName: 'Presa visione',
    active: true,
    value: '',
    status: [],
    type: 'checkbox',
    position: 4,
    pullTo: 'left',
    action: {
      value: 'Attivata',
      type: 'inverse',
      disabled: true,
      fetch: {
        attivata: {
          url: 'wgt/sign/active',
          body: {},
          mappingEvent: 'IframeSrcSetter'
        }
      },
      updateComponentId: 'ATTIVA_REVOCA_FIRMA-IFRAME',
      toggleVisibility: {
        show: {
          fields: ['ATTIVA_REVOCA_FIRMA-IFRAME']
        }
      }
    },
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    description: 'Ho Preso visione',
    toggleVisibility: {
      // show: {
      //   fields: ['ATTIVA_REVOCA_FIRMA-FIRMA']//,'ATTIVA_REVOCA_FIRMA-LABEL']
      // },
      hide: {
        fields: ['ATTIVA_REVOCA_FIRMA-IFRAME']
      }
    }
  },

  'ATTIVA_REVOCA_FIRMA-LABEL': {
    name: 'LABEL',
    cleanName: 'Scegli un codice PIN di firma di 5 cifre e inserisci il codice OTP di firma che hai appena ricevuto sul tuo numero di cellulare',
    active: false,
    value: 'Scegli un codice PIN di firma di 5 cifre e inserisci il codice OTP di firma che hai appena ricevuto sul tuo numero di cellulare',
    status: ['hidden'],
    type: 'label',
    position: 5,
    validations: {
      isRequired: false,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    description: 'Scegli un codice PIN di firma di 5 cifre e inserisci il codice OTP di firma che hai appena ricevuto sul tuo numero di cellulare',
  },

  'DIFARMA_0-LABEL': {
    name: 'LABEL',
    cleanName: 'LABEL'
  },
  'DIFARMA_0-SUB_LABEL': {
    name: 'SUB_LABEL',
    cleanName: 'SUB_LABEL'
  },
  'DIFARMA_0-FIRMA': {
    name: 'Firma',
    cleanName: 'Firma',
    pullTo: 'right',
    position: 3,
    status: [],
    action: {
      value: 'Attivata',
      type: 'inverse',
      disabled: true,
      fetch: {
        attivata: {
          url: 'wgt/utils/presavisione',
          mappingEvent: 'DigiSignature'
        }
      },
    }
  },
  'DIFARMA_0-IFRAME': {
    name: 'IFRAME',
    cleanName: 'IFRAME'
  },
  'DIFARMA_1-LABEL': {
    name: 'LABEL',
    cleanName: 'LABEL'
  },
  'DIFARMA_1-SUB_LABEL': {
    name: 'SUB_LABEL',
    cleanName: 'SUB_LABEL'
  },
 'DIFARMA_1-FIRMA': {
  name: 'Firma',
  cleanName: 'Firma',
  pullTo: 'right',
  position: 3,
  status: [],
  action: {
    value: 'Attivata',
    type: 'inverse',
    disabled: true,
    fetch: {
      attivata: {
        url: 'wgt/utils/presavisione',
        // mappingEvent: 'IframeSrcSetter'
        mappingEvent: 'DigiSignature'
        }
      }
    }
  },
  'DIFARMA_1-IFRAME': {
    name: 'IFRAME',
    cleanName: 'IFRAME'
  },
  'DIFARMA_2-LABEL': {
    name: 'LABEL',
    cleanName: 'LABEL'
  },
  'DIFARMA_2-SUB_LABEL': {
    name: 'SUB_LABEL',
    cleanName: 'SUB_LABEL'
  },
  
  'DIFARMA_2-FIRMA': {
    name: 'Firma',
    cleanName: 'Firma',
    pullTo: 'right',
    position: 3,
    status: [],
    action: {
      value: 'Attivata',
      type: 'inverse',
      disabled: true,
      fetch: {
        attivata: {
          url: 'wgt/utils/presavisione',
          // mappingEvent: 'IframeSrcSetter'
          mappingEvent: 'DigiSignature'
        }
      }
    }
  },
  'DIFARMA_2-IFRAME': {
    name: 'IFRAME',
    cleanName: 'IFRAME'
  },
  'DIFARMA_3-LABEL': {
    name: 'LABEL',
    cleanName: 'LABEL'
  },
  'DIFARMA_3-SUB_LABEL': {
    name: 'SUB_LABEL',
    cleanName: 'SUB_LABEL'
  },
 'DIFARMA_3-FIRMA': {
  name: 'Firma',
  cleanName: 'Firma',
  pullTo: 'right',
  status: [],
  position: 3,
  action: {
    value: 'Attivata',
    type: 'inverse',
    disabled: true,
    fetch: {
      attivata: {
        url: 'wgt/utils/presavisione',
        // mappingEvent: 'IframeSrcSetter'
        mappingEvent: 'DigiSignature'
        }
      }
    }
  },

  'DIFARMA_3-IFRAME': {
    name: 'IFRAME',
    cleanName: 'IFRAME'
  },
  'DIFARMA_4-LABEL': {
    name: 'LABEL',
    cleanName: 'LABEL'
  },
  'DIFARMA_4-SUB_LABEL': {
    name: 'SUB_LABEL',
    cleanName: 'SUB_LABEL'
  },
  'DIFARMA_4-FIRMA': {
    name: 'ATTIVA',
    cleanName: 'ATTIVA',
    pullTo: 'right',
    status: [],
    position: 3,
    action: {
      value: 'Attivata',
      type: 'inverse',
      disabled: true,
      fetch: {
        attivata: {
          url: 'wgt/utils/presavisione',
          // mappingEvent: 'IframeSrcSetter'
          mappingEvent: 'DigiSignature'
        }
      }
    }
  },
  'DIFARMA_4-IFRAME': {
    name: 'IFRAME',
    cleanName: 'IFRAME'
  },
  /* 'ATTIVA_REVOCA_FIRMA-CONTENT1': {
    name: 'CONTENT1'
    // cleanName: 'iFrame',
  },
  'ATTIVA_REVOCA_FIRMA-CONTENT2': {
    name: 'CONTENT2'
    // cleanName: 'iFrame',
  },
  'ATTIVA_REVOCA_FIRMA-ATTIVATA': {
    name: 'ATTIVATA'
    // cleanName: 'iFrame',
    // type: 'button'
  }, */
  'BONIFICO-SPACER': {
    id: 'BONIFICO-SPACER',
    name: 'SELFIE_UPLOAD_SPACER',
    type: 'spacer',
    position: 1,
    value: '',
    status: [],
    extra: true
  },
  'BONIFICO-LABEL': {
    id: 'BONIFICO-LABEL',
    name: 'LABEL',
    type: 'label',
    position: 2,
    isPadded: true,
    isCentered: true,
    cleanName: 'Fatti riconoscere con un bonifico',
    value:
      "Invia un <b>bonifico</b> da un <b>tuo conto</b> al nostro <b>IBAN di verifica</b> inserendo <b>la causale indicata</b>. Dopo l'attivazione l'importo verrà trasferito sul tuo nuovo IBAN.",
    validations: {},
    status: [],
    extra: true
  },
  'BONIFICO-IBAN': {
    name: 'IBAN',
    type: 'text',
    position: 3,
    isDisabled: true,
    cleanName: 'IBAN temporaneo di verifica',
    validations: {}
  },
  'BONIFICO-CAUSALE': {
    name: 'CAUSALE',
    type: 'text',
    position: 4,
    isDisabled: true,
    cleanName: 'Causale',
    validations: {}
  },
  /*  'BUNDLE-VISIONE': {
     name: 'VISIONE',
     type: 'checkbox',
     validations: {
       isRequired: true,
       default: [
         {
           validate: VALIDATION_METHODS.bool,
           getErrorMessage: VALIDATION_ERRORS.filled
         }
       ]
     },
     cleanName: 'Presa visione',
     description:
       'Dichiaro di aver letto la documentazione informativa, di averne compreso e salvato il contenuto.'
   }, */
  'BUNDLE-NOME_PRODOTTO': {
    name: 'NOME_PRODOTTO',
    cleanName: 'Nome prodotto'
  },
  'BUNDLE-DESCRIZIONE': {
    name: 'DESCRIZIONE',
    cleanName: 'Descrizione prodotto'
  },
  'BUNDLE-IMMAGINE_PRODOTTO': {
    name: 'IMMAGINE_PRODOTTO',
    cleanName: 'Immagine prodotto'
  },
  'CAT_IDENTIFICAZIONE-IDENT_BONIFICO': {
    name: 'IDENT_BONIFICO',
    cleanName: 'Identificati tramite bonifico'
  },
  'CAT_IDENTIFICAZIONE-IDENT_WEBCAM': {
    name: 'IDENT_WEBCAM',
    cleanName: 'Identificati tramite webcam'
  },
  'CAT_IDENTIFICAZIONE-IDENT_PERSONA': {
    name: 'IDENT_PERSONA',
    cleanName: 'Identificati di persona'
  },
  'CELLULARE-CODICE_CELLULARE': {
    name: 'CODICE_CELLULARE',
    type: 'text',
    cleanName: 'Codice OTP ricevuto via SMS',//Codice cellulare',
    isDisabled: true,
    fullWidth:true,
    //validMessage:'Ti abbiamo inviato un sms con il codice di accesso',
    validations: {
      isRequired: true,
      skipLazy: true,
      default: [
        {
          validate: VALIDATION_METHODS.otp,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ],
      url: 'wgt/validate/confermacellulare',
      fields: {
        'CELLULARE-PREF_CELLULARE': {
          fieldName: 'prefisso'
        },
        'CELLULARE-NUM_CELLULARE': {
          fieldName: 'numero'
        },
        'CELLULARE-CODICE_CELLULARE': {
          fieldName: 'codice'
        }
      }
    }
  },
  'CELLULARE-CONFERMA_NUM_CELLULARE': {
    name: 'CONFERMA_NUM_CELLULARE',
    type: 'text',
    position: 4,
    cleanName: 'Conferma numero cellulare',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.mobileNumber,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'CELLULARE-CONFERMA_PREF_CELLULARE': {
    name: 'CONFERMA_PREF_CELLULARE',
    type: 'hidden',
    value: '+39',
    cleanName: 'Conferma prefisso cellulare',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.mobilePrefix,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'CELLULARE-NUM_CELLULARE': {
    name: 'NUM_CELLULARE',
    type: 'text',
    otpbtnDisabled: true,
    position: 2,
    cleanName: 'Numero cellulare',
    validations: {
      isRequired: true,
      skipLazy: true,
      default: [
        {
          validate: VALIDATION_METHODS.mobileNumber,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ],
      // url: 'wgt/validate/cellulare',
      // fields: {
      //   'CELLULARE-PREF_CELLULARE': {
      //     fieldName: 'prefisso'
      //   },
      //   'CELLULARE-NUM_CELLULARE': {
      //     fieldName: 'numero'
      //   }
      // },
      // params: [
      //   {
      //     type: 'WIDGET',
      //     entityName: 'CELLULARE',
      //     propName: 'code',
      //     name: 'widgetId'
      //   }
      // ]
    },
    fetch: {
      url: 'wgt/validate/cellulare',
      fields: [{
        'CELLULARE-PREF_CELLULARE': {
          fieldName: 'prefisso'
        },
        'CELLULARE-NUM_CELLULARE': {
          fieldName: 'numero'
        }
      }]
      //mappingEvent:'sendOTP'
    }
  },
  'CELLULARE-PREF_CELLULARE': {
    name: 'PREF_CELLULARE',
    position: 1,
    // type: 'hidden',
    // value: '+39',
    // cleanName: 'Prefisso cellulare',
    // validations: {
    //   isRequired: true,
    //   default: [
    //     {
    //       validate: VALIDATION_METHODS.mobilePrefix,
    //       getErrorMessage: VALIDATION_ERRORS.filled
    //     }
    //   ]
    // }
    type: 'selectbox',
    isDisabled: false,
    options: {
      url: 'wgt/utils/prefissi',
      mapping: { label: 'description', value: 'value' }
    },
    value: '+39',
    label: 'Italia (+39)',
    cleanName: 'Prefisso cellulare',
    validations: {
      isRequired: true
    },
    flag: 'static_1'
  },
  'CHI_CONSIGLIA-CHI_CONSIGLIA': {
    name: 'CHI_CONSIGLIA',
    cleanName: 'Chi consiglia'
  },
  'CITTADINANZA-CITTADINANZA': {
    name: 'CITTADINANZA',
    type: 'selectbox',
    initialValue: 'ITALIA',
    options: {
      url: 'wgt/utils/cittadinanze/VALID',
      mapping: { label: 'nazionalita', value: 'key' }
    },
    cleanName: 'Cittadinanza',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.alphabetic,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    flag: 'static_1'
  },
  'DENOMINAZIONE_AZIENDA-DENOMINAZIONE': {
    name: 'DENOMINAZIONE',
    type: 'text',
    cleanName: 'Ragione Sociale',
    /*options: {
      url: 'wgt/utils/cittadinanze/VALID',
      mapping: { label: 'nazionalita', value: 'key' }
    },*/
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.filled,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    description:
      'Come Da Iscrizione Alla Camera Di Commercio O Agli Albi Professionali'
  },
  'AZIENDA_TYPE-TIPO_SOGGETTO_AZIENDA': {
    name: 'TIPO_SOGGETTO_AZIENDA',
    type: 'selectbox',
    /*initialValue: 'Seleziona un  Tipo Soggetto',*/
    // values: [
    //   // {
    //   //   value: '-1',
    //   //   label: 'Seleziona un  Tipo Soggetto',
    //   //   description: 'Seleziona un  Tipo Soggetto'
    //   // },
    //   // {
    //   //   value: '1052',
    //   //   label: 'Ente privato',
    //   //   description: 'Ente privato'
    //   // },
    //   {
    //     value: '1051',
    //     label: 'Società cooperativa',
    //     description: 'Società Cooperative'
    //   },
    //   {
    //     value: '1050',
    //     label: 'Società di capitali',
    //     description: 'Società di Capitali'
    //   },
    //   {
    //     value: '1049',
    //     label: 'Società di persone',
    //     description: 'Società di Persone, studi associati'
    //   }
    // ],

    options: {
      mapping: { label: 'tipoSoggettoDesc', value: 'tipoSoggettoId' }
    },
    trigger: [
      {
        componentId: 'AZIENDA_SUBTYPE-AZIENDA_TIPO_SOCIETA',
        type: 'fetchOption'
      }
    ],
    cleanName: 'Categoria società', //'Seleziona la categoria',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.filled,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
    /*,
    notifyComponents: {
      validate: ['AZIENDA_SUBTYPE-AZIENDA_TIPO_SOCIETA']
    }*/
  },
  'AZIENDA_SUBTYPE-AZIENDA_TIPO_SOCIETA': {
    name: 'AZIENDA_TIPO_SOCIETA',
    type: 'selectbox',
    /*initialValue: 'Seleziona un Tipo Societa',*/
    options: {
      url: 'wgt/utils/aziendaTipoSocieta',
      mapping: { label: 'description', value: 'value' },
      fields: [
        {
          'AZIENDA_TYPE-TIPO_SOGGETTO_AZIENDA': {
            fieldName: 'value'
          }
        }
      ]
    },
    cleanName: 'Tipo società', //'Seleziona il tipo',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.filled,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'CODICE_FISCALE-CF': {
    name: 'CF',
    type: 'text',
    cleanName: 'Codice Fiscale',
    position: 1,
    validations: {
      skipLazy: true,
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.cf,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ],
      overrides: [
        {
          validate: VALIDATION_METHODS.cfUnderage,
          getErrorMessage: VALIDATION_ERRORS.cfUnderage
        }
      ],
      url: 'wgt/validate/codicefiscale',
      fields: ['CODICE_FISCALE-CF', 'NOME_COGNOME-NOME', 'NOME_COGNOME-COGNOME']
    },
    fetch: {
      questionario: {
        url: 'wgt/utils/splitcf',
        fields: [
          {
            'CODICE_FISCALE-CF': {
              fieldName: 'cf'
            }
          }
        ],
        mappingEvent: 'titolareEffettivo'
      }
    }
  },
  'CODICE_FISCALE-DATADINASCITA': {
    name: 'dataDiNascita',
    type: 'text',
    cleanName: 'Data di nascita*',
    value: '',
    active: false,
    status: ['hidden'],
    extra: true,
    position: 2
  },
  'CODICE_FISCALE-SESSO': {
    name: 'SESSO',
    type: 'label',
    active: false,
    cleanName: 'Sesso*',
    value: '',
    status: ['hidden'],
    extra: true
  },
  'CODICE_FISCALE-PROVINCIADINASCITA': {
    name: 'provinciaDiNascita',
    type: 'label',
    active: false,
    cleanName: 'Provincia',
    value: '',
    status: ['hidden'],
    extra: true
  },
  'CODICE_FISCALE-LUOGODINASCITA': {
    name: 'luogoDiNascita',
    type: 'text',
    active: false,
    cleanName: 'Luogo di nascita*',
    value: '',
    status: ['hidden'],
    extra: true,
    position: 3
  },
  'CODICE_PROMOZIONALE-CODICE_PROMOZIONALE': {
    name: 'CODICE_PROMOZIONALE',
    cleanName: 'Codice promo'
  },
  'CONTO_ADDEBITO-CONTO_ADDEBITO': {
    name: 'CONTO_ADDEBITO',
    cleanName: 'Conto di addebito'
  },
  'CONTO_RIFERIMENTO-CONTO_RIFERIMENTO': {
    name: 'CONTO_RIFERIMENTO',
    cleanName: 'Conto di riferimento'
  },
  'CRONISTORIA-VISIONE': {
    name: 'VISIONE',
    type: 'checkbox',
    cleanName: 'Presa visione',
    validations: {
      //isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    description:
      //'Per dar seguito alla richiesta è necessario il tuo consenso alla conservazione della cronistoria delle attività precontrattuali.'
      'Consensi facoltativi al trattamento dei dati personali.\nCon riferimento al Paragrafo 3 dell’informativa, mi esprimo in merito al trattamento dei miei dati da parte di Axerve ai fini di seguito indicati, consapevole che tale azione è facoltativa e non vincolante alla stipula del contratto:conservazione della documentazione delle attività precontrattuali (es. preventivi, richiesta di prodotti poi non sottoscritti).'
  },
  'DATI_SENSIBILI-VISIONE': {
    name: 'VISIONE',
    type: 'checkbox',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    cleanName: 'Il consenso',//'Presa visione',
    description:
      //'Per dar seguito alla richiesta è necessario il tuo consenso al trattamento dei dati sensibili.\nIMPORTANTE: Non richiediamo e non trattiamo di nostra iniziativa i tuoi "dati sensibili" se non per dare esecuzione alla disposizione delle tue operazioni.\nCi teniamo a precisarti che NON UTILIZZEREMO QUESTI DATI IN ALTRO MODO.'
      'Consenso al trattamento dei dati particolari ai sensi dell’articolo 9 del Regolamento.\nAxerve non richiede e non tratta di propria iniziativa "dati particolari", se non per eseguire le operazioni richieste dal Cliente. Per questo motivo, come riportato nell’informativa che mi è stata consegnata e di cui ho preso visione in riferimento al Paragrafo 8:    mi esprimo in merito al trattamento dei dati particolari, consapevole che tale consenso è vincolante per dare seguito alle operazioni da me richieste.'
  },
  'DOCUMENTAZIONE-DESCR_PRODOTTO': {
    name: 'DESCR_PRODOTTO',
    type: 'label',
    cleanName: 'Descrizione prodotto'
  },
  'DOCUMENTAZIONE-DESCR_PRODOTTO_2': {
    name: 'DESCR_PRODOTTO_2',
    type: 'label',
    cleanName: 'Descrizione prodotto'
  },
  'DOCUMENTAZIONE-DESCR_PRODOTTO_3': {
    name: 'DESCR_PRODOTTO_3',
    type: 'label',
    cleanName: 'Descrizione prodotto'
  },
  'DOCUMENTAZIONE-DESCR_PRODOTTO_4': {
    name: 'DESCR_PRODOTTO_4',
    type: 'label',
    cleanName: 'Descrizione prodotto'
  },
  'DOCUMENTAZIONE-LINK': {
    name: 'LINK',
    type: 'link',
    cleanName: 'Scarica'
  },
  'DOCUMENTAZIONE-LINK_2': {
    name: 'LINK_2',
    type: 'link',
    cleanName: 'Link'
  },
  'DOCUMENTAZIONE-LINK_3': {
    name: 'LINK_3',
    type: 'link',
    cleanName: 'Link'
  },
  'DOCUMENTAZIONE-LINK_4': {
    name: 'LINK_4',
    type: 'link',
    cleanName: 'Link'
  },
  'DOCUMENTAZIONE-NOME_PRODOTTO': {
    name: 'NOME_PRODOTTO',
    type: 'label',
    cleanName: 'Nome prodotto'
  },
  'DOCUMENTAZIONE-NOME_PRODOTTO_2': {
    name: 'NOME_PRODOTTO_2',
    type: 'label',
    cleanName: 'Nome prodotto'
  },
  'DOCUMENTAZIONE-NOME_PRODOTTO_3': {
    name: 'NOME_PRODOTTO_3',
    type: 'label',
    cleanName: 'Nome prodotto'
  },
  'DOCUMENTAZIONE-NOME_PRODOTTO_4': {
    name: 'NOME_PRODOTTO_4',
    type: 'label',
    cleanName: 'Nome prodotto'
  },
  'DOCUMENTAZIONE-VISIONE': {
    name: 'VISIONE',
    type: 'checkbox',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    cleanName: 'Presa visione',
    description:
      'Dichiaro di aver letto la documentazione informativa, di averne compreso e salvato il contenuto.'
  },
  'DOCUMENTO-DATA_RILASCIO': {
    name: 'DATA_RILASCIO',
    type: 'date',
    cleanName: 'Data rilascio',
    position: 5,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.date,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'DOCUMENTO-DATA_SCADENZA': {
    name: 'DATA_SCADENZA',
    type: 'date',
    cleanName: 'Data scadenza',
    position: 6,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.date,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'DOCUMENTO-DOCF_UPLOAD': {
    name: 'DOCF_UPLOAD',
    type: 'file',
    uploadType: 'FRONT_DOC_1',
    position: 7,
    cleanName: 'Carica il fronte del documento',
    modalTitle: 'Carica o scatta il fronte del documento',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.filled,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'DOCUMENTO-DOCR_UPLOAD': {
    name: 'DOCR_UPLOAD',
    uploadType: 'BACK_DOC_1',
    type: 'file',
    position: 8,
    cleanName: 'Carica il retro del documento',
    modalTitle: 'Carica o scatta il retro del documento',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.filled,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'DOCUMENTO-ENTE_RILASCIO': {
    name: 'ENTE_RILASCIO',
    type: 'text',
    // type: 'selectbox',
    // options: {
    //   url: 'wgt/utils/documenti',
    //   mapping: { label: 'enteEmissione', value: 'enteEmissione' }
    // },
    isDisabled: true,
    position: 3,
    cleanName: 'Ente di rilascio',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.alphabetic,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'DOCUMENTO-LUOGO_RILASCIO': {
    name: 'LUOGO_RILASCIO',
    type: 'text',
    position: 4,
    cleanName: 'Luogo di rilascio',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.alphabetic,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  // 'DOCUMENTO-PROVINCIA_RILASCIO': {
  //   name: 'PROVINCIA_RILASCIO',
  //   type: 'text',
  //   position: 4,
  //   cleanName: 'Provincia di rilascio',
  //   validations: {
  //     isRequired: true,
  //     default: [{validate:V(v) => ALIDATION_PATTERNS.alphabetic.test(c.value)}]
  //   }
  // },
  // 'DOCUMENTO-NAZIONE_RILASCIO': {
  //   name: 'NAZIONE_RILASCIO',
  //   type: 'text',
  //   position: 4,
  //   cleanName: 'Nazione di rilascio',
  //   validations: {
  //     isRequired: true,
  //     default: [{validate:V(v) => ALIDATION_PATTERNS.alphabetic.test(c.value)}]
  //   }
  // },
  'DOCUMENTO-NUMERO_DOCUMENTO': {
    name: 'NUMERO_DOCUMENTO',
    type: 'text',
    position: 2,
    cleanName: 'Numero documento',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.alphanumeric,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'DOCUMENTO-TIPO_DOCUMENTO': {
    name: 'TIPO_DOCUMENTO',
    type: 'selectbox',
    position: 1,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.alphabetic,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    toggleVisibility: {
      show: {
        fields: ['DOCUMENTO-DOCUMENTRULES2']
      },
      hide:{
        fields: ['DOCUMENTO-DOCUMENTRULES']
      }
    },
    options: {
      url: 'wgt/utils/documenti',
      mapping: { label: 'nome', value: 'nome', enteEmissione: 'enteEmissione' }
    },
    autofill: {
      mapping: [
        {
          key: 'value',
          resKey: 'enteEmissione',
          componentId: 'DOCUMENTO-ENTE_RILASCIO'
        }
      ]
    },
    cleanName: 'Tipo di documento'
  },
  // 'DOCUMENTO_2-BOLLETTA': {
  //   name: 'BOLLETTA',
  //   cleanName: 'Bolletta',
  //   type: 'radio',
  //   validations: {
  //     isRequired: true,
  //     default: [
  //       {
  //         validate: VALIDATION_METHODS.bool,
  //         getErrorMessage: VALIDATION_ERRORS.filled
  //       }
  //     ]
  //   },
  //   position: 1,
  //   trigger: [
  //     {
  //       componentId: 'DOCUMENTO_2-ENTE_RILASCIO',
  //       /*componentIds: [
  //         'DOCUMENTO_2-ENTE_RILASCIO',
  //         'DOCUMENTO_2-LUOGO_RILASCIO',
  //         'DOCUMENTO_2-NUMERO_DOCUMENTO',
  //         'DOCUMENTO_2-DATA_RILASCIO',
  //         'DOCUMENTO_2-DATA_SCADENZA',
  //         'DOCUMENTO_2-DOCR_UPLOAD'
  //       ],*/
  //       type: 'copy',
  //       value: ''
  //     }
  //   ],
  //   toggleVisibility: {
  //     show: {
  //       fields: ['DOCUMENTO_2-DOCF_UPLOAD', 'DOCUMENTO_2-SECONDDOCUMENTRULE1']
  //     },
  //     hide: {
  //       fields: [
  //         'DOCUMENTO_2-ENTE_RILASCIO',
  //         'DOCUMENTO_2-LUOGO_RILASCIO',
  //         'DOCUMENTO_2-NUMERO_DOCUMENTO',
  //         'DOCUMENTO_2-DATA_RILASCIO',
  //         'DOCUMENTO_2-DATA_SCADENZA',
  //         'DOCUMENTO_2-DOCR_UPLOAD',
  //         'DOCUMENTO_2-SECONDDOCUMENTRULE2',
  //         'DOCUMENTO_2-SECONDDOCUMENTRULE3'
  //       ]
  //     }
  //   }
  // },
  'DOCUMENTO_2-BUSTA_PAGA': {
    name: 'BUSTA_PAGA',
    cleanName: 'Busta paga',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    position: 1,
    trigger: [
      {
        componentId: 'DOCUMENTO_2-ENTE_RILASCIO',
        type: 'copy',
        value: ''
      }
    ],
    toggleVisibility: {
      show: {
        fields: ['DOCUMENTO_2-DOCF_UPLOAD', 'DOCUMENTO_2-SECONDDOCUMENTRULE1']
      },
      hide: {
        fields: [
          'DOCUMENTO_2-ENTE_RILASCIO',
          'DOCUMENTO_2-LUOGO_RILASCIO',
          'DOCUMENTO_2-NUMERO_DOCUMENTO',
          'DOCUMENTO_2-DATA_RILASCIO',
          'DOCUMENTO_2-DATA_SCADENZA',
          'DOCUMENTO_2-DOCR_UPLOAD',
          'DOCUMENTO_2-SECONDDOCUMENTRULE2',
          'DOCUMENTO_2-SECONDDOCUMENTRULE3'
        ]
      }
    }
  },
  // 'DOCUMENTO_2-ESTRATTO_CONTO': {
  //   name: 'ESTRATTO_CONTO',
  //   cleanName: 'Estratto conto',
  //   type: 'radio',
  //   validations: {
  //     isRequired: true,
  //     default: [
  //       {
  //         validate: VALIDATION_METHODS.bool,
  //         getErrorMessage: VALIDATION_ERRORS.filled
  //       }
  //     ]
  //   },
  //   position: 3,
  //   trigger: [
  //     {
  //       componentId: 'DOCUMENTO_2-ENTE_RILASCIO',
  //       type: 'copy',
  //       value: ''
  //     }
  //   ],
  //   toggleVisibility: {
  //     show: {
  //       fields: ['DOCUMENTO_2-DOCF_UPLOAD', 'DOCUMENTO_2-SECONDDOCUMENTRULE1']
  //     },
  //     hide: {
  //       fields: [
  //         'DOCUMENTO_2-ENTE_RILASCIO',
  //         'DOCUMENTO_2-LUOGO_RILASCIO',
  //         'DOCUMENTO_2-NUMERO_DOCUMENTO',
  //         'DOCUMENTO_2-DATA_RILASCIO',
  //         'DOCUMENTO_2-DATA_SCADENZA',
  //         'DOCUMENTO_2-DOCR_UPLOAD',
  //         'DOCUMENTO_2-SECONDDOCUMENTRULE2',
  //         'DOCUMENTO_2-SECONDDOCUMENTRULE3'
  //       ]
  //     }
  //   }
  // },
  'DOCUMENTO_2-CARTA_IDENTITA': {
    name: 'CARTA_IDENTITA',
    cleanName: 'Carta di Identità',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    trigger: [
      {
        componentId: 'DOCUMENTO_2-ENTE_RILASCIO',
        type: 'copy',
        value: 'COMUNE'
      }
    ],
    position: 2,
    toggleVisibility: {
      show: {
        fields: [
          'DOCUMENTO_2-ENTE_RILASCIO',
          'DOCUMENTO_2-LUOGO_RILASCIO',
          'DOCUMENTO_2-NUMERO_DOCUMENTO',
          'DOCUMENTO_2-DATA_RILASCIO',
          'DOCUMENTO_2-DATA_SCADENZA',
          'DOCUMENTO_2-DOCR_UPLOAD',
          'DOCUMENTO_2-SECONDDOCUMENTRULE3'
        ]
      },
      hide: {
        fields: [
          'DOCUMENTO_2-SECONDDOCUMENTRULE2','DOCUMENTO_2-SECONDDOCUMENTRULE1',
        ]
      }
    }
  },
  'DOCUMENTO_2-PERMESSO_SOGGIORNO': {
    name: 'PERMESSO_SOGGIORNO',
    cleanName: 'Permesso di soggiorno'
  },
  'DOCUMENTO_2-PASSAPORTO': {
    name: 'PASSAPORTO',
    cleanName: 'Passaporto',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    trigger: [
      {
        componentId: 'DOCUMENTO_2-ENTE_RILASCIO',
        type: 'copy',
        value: 'QUESTURA'
      }
    ],
    position: 3,
    toggleVisibility: {
      show: {
        fields: [
          'DOCUMENTO_2-ENTE_RILASCIO',
          'DOCUMENTO_2-LUOGO_RILASCIO',
          'DOCUMENTO_2-NUMERO_DOCUMENTO',
          'DOCUMENTO_2-DATA_RILASCIO',
          'DOCUMENTO_2-DATA_SCADENZA',
          'DOCUMENTO_2-DOCR_UPLOAD',
          'DOCUMENTO_2-SECONDDOCUMENTRULE3'
        ]
      },
      hide: {
        fields: [
          'DOCUMENTO_2-SECONDDOCUMENTRULE2','DOCUMENTO_2-SECONDDOCUMENTRULE1',
        ]
      }
    }
  },
  'DOCUMENTO_2-PATENTE': {
    name: 'PATENTE',
    cleanName: 'Patente',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    trigger: [
      {
        componentId: 'DOCUMENTO_2-ENTE_RILASCIO',
        type: 'copy',
        value: 'UFFICIO PROVINCIALE MCTC'
      }
    ],
    position: 4,
    toggleVisibility: {
      show: {
        fields: [
          'DOCUMENTO_2-ENTE_RILASCIO',
          'DOCUMENTO_2-LUOGO_RILASCIO',
          'DOCUMENTO_2-NUMERO_DOCUMENTO',
          'DOCUMENTO_2-DATA_RILASCIO',
          'DOCUMENTO_2-DATA_SCADENZA',
          'DOCUMENTO_2-DOCR_UPLOAD',
          'DOCUMENTO_2-SECONDDOCUMENTRULE3'
        ]
      },
      hide: {
        fields: [
          'DOCUMENTO_2-SECONDDOCUMENTRULE2','DOCUMENTO_2-SECONDDOCUMENTRULE1',
        ]
      }
    }
  },
  'DOCUMENTO_2-TESSERA_SANITARIA': {
    name: 'TESSERA_SANITARIA',
    cleanName: 'Tessera sanitaria',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    trigger: [
      {
        componentId: 'DOCUMENTO_2-ENTE_RILASCIO',
        type: 'copy',
        value: 'MEF'
      }
    ],
    position: 5,
    toggleVisibility: {
      // show: {
      //   fields: ['DOCUMENTO_2-DOCF_UPLOAD', 'DOCUMENTO_2-SECONDDOCUMENTRULE1']
      // },
      // hide: {
      //   fields: [
      //     'DOCUMENTO_2-ENTE_RILASCIO',
      //     'DOCUMENTO_2-LUOGO_RILASCIO',
      //     'DOCUMENTO_2-NUMERO_DOCUMENTO',
      //     'DOCUMENTO_2-DATA_RILASCIO',
      //     'DOCUMENTO_2-DATA_SCADENZA',
      //     'DOCUMENTO_2-DOCR_UPLOAD',
      //     'DOCUMENTO_2-SECONDDOCUMENTRULE2',
      //     'DOCUMENTO_2-SECONDDOCUMENTRULE3'
      //   ]
      // }
      show: {
        fields: [
          'DOCUMENTO_2-DOCR_UPLOAD',
          'DOCUMENTO_2-SECONDDOCUMENTRULE3'
        ]
      },
      hide: {
        fields: [
          'DOCUMENTO_2-SECONDDOCUMENTRULE2',
          'DOCUMENTO_2-SECONDDOCUMENTRULE1',
          'DOCUMENTO_2-NUMERO_DOCUMENTO',
          'DOCUMENTO_2-LUOGO_RILASCIO',
          'DOCUMENTO_2-DATA_RILASCIO',
          'DOCUMENTO_2-DATA_SCADENZA',
          'DOCUMENTO_2-ENTE_RILASCIO'
          
        ]
      }
    }
  },
  'DOCUMENTO_2-NUMERO_DOCUMENTO': {
    name: 'NUMERO_DOCUMENTO',
    type: 'text',
    position: 6,
    cleanName: 'Numero documento',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.alphanumeric,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'DOCUMENTO_2-LUOGO_RILASCIO': {
    name: 'LUOGO_RILASCIO',
    type: 'text',
    position: 7,
    cleanName: 'Luogo di rilascio',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.alphabetic,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'DOCUMENTO_2-DATA_RILASCIO': {
    name: 'DATA_RILASCIO',
    type: 'date',
    cleanName: 'Data rilascio',
    position: 8,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.date,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'DOCUMENTO_2-DATA_SCADENZA': {
    name: 'DATA_SCADENZA',
    type: 'date',
    cleanName: 'Data scadenza',
    position: 9,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.date,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'DOCUMENTO_2-DOCF_UPLOAD': {
    name: 'DOCF_UPLOAD',
    type: 'file',
    uploadType: 'FRONT_DOC_2',
    position: 10,
    cleanName: 'Carica il fronte del documento',
    modalTitle: 'Carica o scatta il fronte del documento',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.filled,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'DOCUMENTO_2-DOCR_UPLOAD': {
    name: 'DOCR_UPLOAD',
    uploadType: 'BACK_DOC_2',
    type: 'file',
    position: 11,
    cleanName: 'Carica il retro del documento',
    modalTitle: 'Carica o scatta il retro del documento',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.filled,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'DOCUMENTO_2-ENTE_RILASCIO': {
    name: 'ENTE_RILASCIO',
    type: 'text',
    // type: 'selectbox',
    // options: {
    //   url: 'wgt/utils/documenti',
    //   mapping: { label: 'enteEmissione', value: 'enteEmissione' }
    // },
    isDisabled: true,
    position: 13,
    cleanName: 'Ente di emissione',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.alphabetic,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  // 'DOCUMENTO_2-PROVINCIA_RILASCIO': {
  //   name: 'PROVINCIA_RILASCIO',
  //   type: 'text',
  //   position: 4,
  //   cleanName: 'Provincia di rilascio',
  //   validations: {
  //     isRequired: true,
  //     default: [{validate:V(v) => ALIDATION_PATTERNS.alphabetic.test(c.value)}]
  //   }
  // },
  // 'DOCUMENTO_2-NAZIONE_RILASCIO': {
  //   name: 'NAZIONE_RILASCIO',
  //   type: 'text',
  //   position: 4,
  //   cleanName: 'Nazione di rilascio',
  //   validations: {
  //     isRequired: true,
  //     default: [{validate:V(v) => ALIDATION_PATTERNS.alphabetic.test(c.value)}]
  //   }
  // },

  'DOCUMENTO_2-TIPO_DOCUMENTO': {
    name: 'TIPO_DOCUMENTO',
    type: 'selectbox',
    position: 12,
    active: true,
    status: ['hidden'],
    options: {
      url: 'wgt/utils/documenti',
      mapping: { label: 'nome', value: 'nome', enteEmissione: 'enteEmissione' }
    },
    autofill: {
      mapping: [
        {
          key: 'value',
          resKey: 'enteEmissione',
          componentId: 'DOCUMENTO_2-ENTE_RILASCIO'
        }
      ]
    },
    cleanName: 'Tipo di documento'
  },
  //Changes for loading new 'VAT IDENTIFICATION CERTIFICATE' widget 
  'DOCUMENTO_GENERICO-DOC_UPLOAD':{
    name: 'DOCUMENTO_GENERICO',
    uploadType: 'FRONT_DOC_',
    type: 'file',
    position: 3,
    cleanName: 'Certificato',
    modalTitle: 'DOCUMENTO_GENERICO',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.filled,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'DOCUMENTO_GENERICO-SUB_LABEL' : {
    id: 'DOCUMENTO_GENERICO-SUB_LABEL',
    name: 'SUB_LABEL',
    type: 'label',
    value:
      'Solo nel caso in cui tu sia un libero professionista, allega qui il tuo certificato di attribuzione partita IVA',
    position: 1,
    status: [],
    extra: true

  },
  
  //Pos Changes for new widget label 
  'DOCUMENTO_GENERICO-NOTES': {
    id: 'DOCUMENTO_GENERICO-NOTES',
    name: 'NOTES',
    type: 'label',
    value:
      `<b>Il documento è necessario solo per liberi professionisti:</b>
      <br>I formati accettati sono: PDF, JPEG, GIF, PNG, PJPEG, X-PNG. Il peso massimo consentito per documento è di 7MB. Per un documento PDF, il numero massimo di pagine consentite è 4.`,
    position: 4,
    status: [],
    isSmall: true,
    extra: true

  },

  'DOMICILIO-CAP': {
    name: 'CAP',
    type: 'text',
    cleanName: 'CAP',
    position: 2,
    autofill: {
      url: 'wgt/utils/dettaglicapfromegon',
      errorMessage: 'il CAP non è valido',
      mapping: [
        {
          key: 'capCode',
          componentId: 'DOMICILIO-CAP'
        },
        // {
        //   key: 'stato',
        //   componentId: 'DOMICILIO-NAZIONE'
        // },
        {
          key: 'provincia',
          componentId: 'DOMICILIO-PROVINCIA'
        },
        {
          key: 'localita',
          componentId: 'DOMICILIO-CITTA'
        }
      ]
    },
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.cap,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'DOMICILIO-PROVINCIA': {
    name: 'PROVINCIA',
    type: 'selectbox',
    cleanName: 'Provincia',
    //isDisabled: true,
    position: 4,
    // autofill: {
    //   url: 'wgt/utils/comunifromegon',
    //   errorMessage: 'la provincia non è valida',
    //   mapping: [
    //     {
    //       key: 'provincia',
    //       componentId: 'DOMICILIO-PROVINCIA'
    //     },
    //     {
    //       key: 'localita',
    //       componentId: 'DOMICILIO-CITTA',
    //       excludeFromPayload: true
    //     },
    //     {
    //       key: 'capCode',
    //       componentId: 'DOMICILIO-CAP',
    //       excludeFromPayload: true
    //     }
    //   ]
    // },
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.alphabetic,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    options: {
      url: 'wgt/utils/provincefromegon',
      mapping: { label: 'sigla', value: 'sigla' },
      fields: [
        {
          'DOMICILIO-NAZIONE': {
            fieldName: 'nome'
          }
        }
      ]
    },
    notifyComponents: {
      validate: ['DOMICILIO-INDIRIZZO']
    },
    flag: 'static_1'
  },

  'DOMICILIO-CITTA': {
    name: 'CITTA',
    type: 'selectbox',
    isDisabled: true,
    cleanName: 'Città',
    position: 5,
    options: {
      // url: 'wgt/utils/comunifromegon',
      mapping: { label: 'localita', value: 'localita' },
      fields: [
        {
          'DOMICILIO-PROVINCIA': {
            fieldName: 'provincia'
          }
        }
      ]
    },
    autofill: {
      mapping: [
        {
          key: 'localita',
          resKey: 'provincia',
          componentId: 'DOMICILIO-PROVINCIA'
        }
      ]
    },
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.city,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    notifyComponents: {
      validate: ['DOMICILIO-INDIRIZZO']
    }
  },
  'DOMICILIO-INDIRIZZO': {
    name: 'INDIRIZZO',
    type: 'text',
    cleanName: 'Indirizzo e numero civico',
    modalTitle: "Verifica l'indirizzo di domicilio",
    position: 6,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.address,
          getErrorMessage: VALIDATION_ERRORS.address
        }
      ]
      // url: 'wgt/validate/indirizzo',
      // lazy: true,
      // fields: [
      //   'DOMICILIO-NAZIONE',
      //   'DOMICILIO-PROVINCIA',
      //   'DOMICILIO-CAP',
      //   'DOMICILIO-CITTA',
      //   'DOMICILIO-INDIRIZZO',
      //   'DOMICILIO-INDIRIZZO_TIPO'
      // ],
      // mapping: {
      //   'DOMICILIO-CAP': 'cap',
      //   'DOMICILIO-NAZIONE': 'nazione',
      //   'DOMICILIO-PROVINCIA': 'provincia',
      //   'DOMICILIO-CITTA': 'citta',
      //   'DOMICILIO-INDIRIZZO': 'indirizzo',
      //   'DOMICILIO-INDIRIZZO_TIPO': 'tipoIndirizzo'
      // }
    },
    hint: {
      value: HINTS.address,
      visible: false
    }
  },
  'DOMICILIO-NAZIONE': {
    name: 'NAZIONE',
    type: 'selectbox',
    cleanName: 'Nazione',
    value: 'ITALIA',
    //isDisabled:true,
    position: 7,
    //value:'ITALIA'
    // options: {
    //    url: 'wgt/utils/nazionifromegon',
    //   fields: [{}]
    // },
    // validations: {
    //   isRequired: true,
    //   default: [
    //     {
    //       validate: VALIDATION_METHODS.selected,
    //       getErrorMessage: VALIDATION_ERRORS.filled
    //     }
    //   ]
    // },
    flag: 'static_1'
  },
  'DOMICILIO-INDIRIZZO_TIPO': {
    id: 'DOMICILIO-INDIRIZZO_TIPO',
    name: 'INDIRIZZO_TIPO',
    type: 'hidden',
    value: 'IRE',
    status: [],
    extra: true
  },
  'DOMICILIO-ALTRO': {
    name: 'ALTRO',
    type: 'radio',
    cleanName: 'Altro',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    position: 2,
    toggleVisibility: {
      show: {
        fields: [
          'DOMICILIO-PROVINCIA',
          'DOMICILIO-CITTA',
          'DOMICILIO-CAP',
          'DOMICILIO-INDIRIZZO',
          'DOMICILIO-NAZIONE'
        ]
      }
    }
  },
  'DOMICILIO-RESIDENZA': {
    name: 'RESIDENZA',
    type: 'radio',
    value: 'selected',
    cleanName: 'Coincide con residenza',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    position: 1,
    toggleVisibility: {
      hide: {
        fields: [
          'DOMICILIO-PROVINCIA',
          'DOMICILIO-CITTA',
          'DOMICILIO-CAP',
          'DOMICILIO-INDIRIZZO',
          'DOMICILIO-NAZIONE'
        ]
      }
    }
  },
  'EMAIL-CODICE_EMAIL': {
    name: 'CODICE_EMAIL',
    type: 'hidden',
    cleanName: 'Codice email'
  },
  'EMAIL-EMAIL': {
    name: 'EMAIL',
    type: 'text',
    position: 1,
    fullWidth:true,
    cleanName: 'Email',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.email,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'EMAIL-CONFERMA_EMAIL': {
    name: 'CONFERMA_EMAIL',
    type: 'text',
    position: 2,
    cleanName: 'Conferma email',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.email,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'FIRMA-IFRAME': {
    name: 'IFRAME',
    cleanName: 'iFrame',
    type: '',
    pullTo: 'right',
    position: 2,
    action: () => {}
  },
  'INTERESSI_CC-INTERESSI': {
    name: 'INTERESSI',
    cleanName: 'Interessi'
  },
  'INTESTATARI_FISSI-LABEL': {
    name: 'LABEL',
    type: 'label',
    value: '',
    cleanName: 'Label'
  },
  'INTESTATARI_FISSI-INTESTATARI_1': {
    name: 'INTESTATARI_1',
    type: 'hidden',
    cleanName: 'Intestatari'
  },
  'INVITO_INTESTATARI-LABEL': {
    id: 'INVITO_INTESTATARI-LABEL',
    name: 'LABEL',
    type: 'label',
    value:
      'Hype può essere utilizzato dai minori autorizzati da un genitore o da un tutore, il quale riceverà una e-mail che gli permetterà di inserire i propri dati in totale riservatezza.',
    position: 0,
    status: [],
    extra: true
  },
  'INVITO_INTESTATARI-LABEL2': {
    id: 'INVITO_INTESTATARI-LABEL2',
    name: 'SPACER',
    type: 'label',
    value:
      'Il genitore/tutore riceverà tramite e-mail documentazione periodica relativa alle operazioni effettuate.',
    position: 0,
    status: [],
    extra: true
  },
  'INVITO_INTESTATARI-CF': {
    name: 'CF',
    type: 'text',
    cleanName: 'Codice Fiscale',
    position: 9,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.cf,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ],
      url: 'wgt/validate/codicefiscale',
      fields: [
        'INVITO_INTESTATARI-CF',
        'INVITO_INTESTATARI-NOME',
        'INVITO_INTESTATARI-COGNOME'
      ]
    }
  },
  'INVITO_INTESTATARI-CF_1': {
    name: 'CF_1',
    type: 'hidden',
    cleanName: 'Codice Fiscale',
    position: 9,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.cf,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ],
      url: 'wgt/validate/codicefiscale',
      fields: [
        'INVITO_INTESTATARI-CF_1',
        'INVITO_INTESTATARI-NOME',
        'INVITO_INTESTATARI-COGNOME'
      ]
    }
  },
  'INVITO_INTESTATARI-COGNOME': {
    name: 'COGNOME',
    type: 'text',
    cleanName: 'Cognome',
    position: 2,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.alphabetic,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    notifyComponents: {
      validate: ['INVITO_INTESTATARI-CF']
    }
  },
  'INVITO_INTESTATARI-COGNOME_1': {
    name: 'COGNOME_1',
    type: 'hidden',
    cleanName: 'Cognome',
    position: 7,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.alphabetic,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'INVITO_INTESTATARI-EMAIL': {
    name: 'EMAIL',
    type: 'text',
    cleanName: 'Email',
    position: 3,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.email,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ],
      overrides: [
        {
          validate: VALIDATION_METHODS.underageContactConflict,
          getErrorMessage: VALIDATION_ERRORS.underageContactConflict
        }
      ]
    }
  },
  'INVITO_INTESTATARI-EMAIL_1': {
    name: 'EMAIL_1',
    type: 'hidden',
    cleanName: 'Conferma email',
    position: 4,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.email,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'INVITO_INTESTATARI-NOME': {
    name: 'NOME',
    type: 'text',
    cleanName: 'Nome',
    position: 1,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.alphabetic,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    notifyComponents: {
      validate: ['INVITO_INTESTATARI-CF']
    }
  },
  'INVITO_INTESTATARI-NOME_1': {
    name: 'NOME_1',
    type: 'hidden',
    cleanName: 'Nome',
    position: 7,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.alphabetic,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'INVITO_INTESTATARI-NUM_CELLULARE': {
    name: 'NUM_CELLULARE',
    type: 'text',
    cleanName: 'Numero cellulare',
    position: 5,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.mobileNumber,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ],
      overrides: [
        {
          validate: VALIDATION_METHODS.underageContactConflict,
          getErrorMessage: VALIDATION_ERRORS.underageContactConflict
        }
      ]
    }
  },
  'INVITO_INTESTATARI-NUM_CELLULARE_1': {
    name: 'NUM_CELLULARE_1',
    type: 'hidden',
    position: 6,
    cleanName: 'Conferma numero cellulare',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.mobileNumber,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'INVITO_INTESTATARI-PREF_CELLULARE': {
    name: 'PREF_CELLULARE',
    type: 'hidden',
    value: '+39',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.mobilePrefix,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
    // type: 'selectbox',
    // isDisabled: true,
    // options: {
    //   url: 'wgt/utils/prefissi',
    //   mapping: { label: 'description', value: 'value' }
    // },
    // value: '+39',
    // cleanName: 'Prefisso cellulare',
    // validations: {
    //   isRequired: true
    // }
  },
  'INVITO_INTESTATARI-PREF_CELLULARE_1': {
    name: 'PREF_CELLULARE_1',
    type: 'hidden',
    value: '+39',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.mobilePrefix,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
    // type: 'selectbox',
    // isDisabled: true,
    // options: {
    //   url: 'wgt/utils/prefissi',
    //   mapping: { label: 'description', value: 'value' }
    // },
    // value: '+39',
    // cleanName: 'Prefisso cellulare',
    // validations: {
    //   isRequired: true
    // }
  },
  'LABEL-LABEL': {
    name: 'LABEL',
    type: 'label',
    cleanName: 'Label'
  },
  'LABEL-SUB_LABEL': {
    name: 'SUB_LABEL',
    type: 'label',
    cleanName: 'Sublabel',
    status: []
  },
  'MOD_IDENTIFICAZIONE-SELFIE_1_DOCUMENTO': {
    name: 'SELFIE_1_DOCUMENTO',
    type: 'hidden',
    position: 1,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    cleanName: 'Selfie con documento in mano',
    toggleVisibility: {
      show: { fields: ['SELFIE'] },
      hide: { fields: ['DOCUMENTO_2'] }
    }
  },
  'MOD_IDENTIFICAZIONE-BONIFICO_1_DOCUMENTO': {
    name: 'BONIFICO_1_DOCUMENTO',
    type: 'radio',
    position: 2,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    cleanName: 'Bonifico',
    description:
      'Se hai un conto a te intestato, puoi utilizzare anche questo metodo per farti riconoscere',
    toggleVisibility: {
      show: { fields: ['BONIFICO'] },
      hide: { fields: ['SELFIE'] }
    }
  },
  'MOD_IDENTIFICAZIONE-SELFIE_BONIFICO_DOCUMENTO': {
    name: 'SELFIE_BONIFICO_DOCUMENTO',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    cleanName: 'Selfie bonifico e documento'
  },
  'MOD_IDENTIFICAZIONE-SELFIE_2_DOCUMENTI': {
    name: 'SELFIE_2_DOCUMENTI',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    cleanName: 'Selfie con documento in mano',
    description:
      'Volto e documento devono essere ben visibili per essere sicuri che sia davvero tu'
  },
  'MOD_IDENTIFICAZIONE-BONIFICO_2_DOCUMENTI': {
    name: 'BONIFICO_2_DOCUMENTI',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    cleanName: 'Bonifico',
    description:
      'Se hai un conto a te intestato, puoi utilizzare anche questo metodo per farti riconoscere'
  },
  'MOD_IDENTIFICAZIONE-PERSONA': {
    name: 'PERSONA',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    cleanName: 'Persona'
  },
  'MOD_IDENTIFICAZIONE-2_DOCUMENTI': {
    name: '2_DOCUMENTI',
    type: 'radio',
    //value: 'selected',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    toggleVisibility: {
      show: { fields: ['DOCUMENTO_2'] },
      hide: { fields: ['SELFIE'] }
    },
    cleanName: '2 Documenti'
  },
  'MOD_IDENTIFICAZIONE-VIDEO_2_DOCUMENTI': {
    name: 'VIDEO_2_DOCUMENTI',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    cleanName: 'Video 2 Documenti'
  },
  'NOME_COGNOME-COGNOME': {
    name: 'COGNOME',
    type: 'text',
    cleanName: 'Cognome',
    position: 2,
    notifyComponents: {
      validate: ['CODICE_FISCALE-CF']
    },
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.alphabetic,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'NOME_COGNOME-NOME': {
    name: 'NOME',
    type: 'text',
    cleanName: 'Nome',
    position: 1,
    notifyComponents: {
      validate: ['CODICE_FISCALE-CF']
    },
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.alphabetic,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'NUMERO_INTESTATARI-INTESTATARI_1': {
    name: 'INTESTATARI_1',
    type: 'hidden',
    cleanName: 'Intestatari'
  },
  'NUMERO_INTESTATARI-INTESTATARI_2': {
    name: 'INTESTATARI_2',
    type: 'hidden',
    cleanName: 'Intestatari'
  },
  'NUMERO_INTESTATARI-INTESTATARI_3': {
    name: 'INTESTATARI_3',
    type: 'hidden',
    cleanName: 'Intestatari'
  },
  // 'PRIVACY-PRIVACY': {
  //   id: 'PRIVACY-PRIVACY',
  //   name: 'PRIVACY',
  //   type: 'checkbox',
  //   value: '',
  //   pullTo: 'left',
  //   active: true,
  //   cleanName: 'Privacy',
  //   status: [],
  //   position: 1,
  //   validations: {
  //     isRequired: true,
  //     default: [
  //       {
  //         validate: VALIDATION_METHODS.bool,
  //         getErrorMessage: VALIDATION_ERRORS.filled
  //       }
  //     ]
  //   },
  //   description: '',
  //   descriptionWithLink: true,
  //   combineComponent: {
  //     id: 'PRIVACY-PRIVACY_TEXT',
  //     name: 'PRIVACY_TEXT',
  //     type: 'labelWithLink',
  //     pullTo: 'right',
  //     status: [],
  //     link: {
  //       placeholder: '§link§',
  //       text: "l'informativa in materia di privacy",
  //       url:
  //         //'https://www.hype.it/SSRDocumentDisplayer?dtdPG=INFORMATIVA_PRIVACY_HYPE&dtdPE=1',
  //         'https://www.axerve.com/site/privacy-policy/',
  //       target: '_blank'
  //     },
  //     value: 'Cliccando su continua dichiaro di aver letto §link§',
  //     extra: true,
  //     // position: 2,
  //     // style: {'margin-left'}
  //     element: 'span'
  //   }
  // },
  'PRIVACY-PRIVACY': {
    id: 'PRIVACY-PRIVACY',
    name: 'PRIVACY',
    type: 'labelWithLink',
    status: [],
    link: {
      placeholder: '§link§',
      text: "l'informativa in materia di privacy",
      url:'https://www.axerve.com/site/privacy-policy/',
      target: '_blank'
    },
    value: 'Cliccando su continua dichiaro di aver letto §link§',
    additionalView: props => (props.plan === 'flat' || props.plan === 'flatCRS') && <div className="grayed mt-5">Se sei già in possesso di un <b>codice coupon</b> puoi inserirlo all'ultimo step dopo la firma dei contratti, prima dell'invio della pratica.</div>,
    active: true,
    position: 2,
    element: 'span'
  },
  'PROFESSIONE_ATTIVITA-PROFESSIONE': {
    name: 'PROFESSIONE',
    type: 'selectbox',
    cleanName: 'Professione',
    position: 1,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.filled,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    options: {
      url: 'wgt/utils/professioni',
      mapping: { label: 'description', value: 'value' },
      fields: [{}]
    },

    trigger: [
      {
        componentId: 'PROFESSIONE_ATTIVITA-SETTORE',
        type: 'fetchOption'
      },
      {
        componentId: 'PROFESSIONE_ATTIVITA-ATTIVITA',
        type: 'fetchOption'
      }
      //,
      // {
      //   componentId: 'PROFESSIONE_ATTIVITA-ATTIVITA',
      //   type: 'fetch'
      // }
    ],
    fetch: {
      questionario: {
        url: 'wgt/ar/getQuestionario',//'wgt/acol/get',
        body: {
          contesto:'ACOLProspect_PF',
          viewMode: false
        },
        fields: [
          {
            'PROFESSIONE_ATTIVITA-PROFESSIONE': {
              fieldName: 'profession'
            }
          },
          {
            'PROFESSIONE_ATTIVITA-ATTIVITA': {
              fieldName: 'attivita'
            }
          },
          {
            'PROFESSIONE_ATTIVITA-ATTIVITA': {
              fieldName: 'attivitaEconomica'
            }
          }
        ],
        mappingEvent: 'questionario'
      }
    }
  },
  'PROFESSIONE_ATTIVITA-SETTORE': {
    name: 'SETTORE',
    type: 'selectbox',
    cleanName: 'Settore',
    position: 2,
    options: {
      url: 'wgt/utils/settori',
      mapping: { label: 'description', value: 'value' },
      fields: [
        {
          'PROFESSIONE_ATTIVITA-PROFESSIONE': {
            fieldName: 'value'
          }
        }
      ]
    },
    trigger: [
      {
        componentId: 'PROFESSIONE_ATTIVITA-ATTIVITA',
        type: 'fetchOption'
      }
      // ,
      // {
      //   componentId: 'PROFESSIONE_ATTIVITA-ATTIVITA',
      //   type: 'fetch'
      // }
    ],
    fetch: {
      questionario: {
        url: 'wgt/ar/getQuestionario',//'wgt/acol/get',
        body: {
          contesto:'ACOLProspect_PF',
          viewMode: false
        },
        fields: [
          {
            'PROFESSIONE_ATTIVITA-PROFESSIONE': {
              fieldName: 'profession'
            }
          },
          {
            'PROFESSIONE_ATTIVITA-ATTIVITA': {
              fieldName: 'attivita'
            }
          },
          {
            'PROFESSIONE_ATTIVITA-ATTIVITA': {
              fieldName: 'attivitaEconomica'
            }
          }
        ],
        mappingEvent: 'questionario'
      }
    },
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.filled,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'PROFESSIONE_ATTIVITA-ATTIVITA': {
    name: 'ATTIVITA',
    type: 'selectbox',
    position: 3,
    cleanName: 'Attività economica',
    options: {
      url: 'wgt/utils/attivita',
      mapping: { label: 'description', value: 'value' },
      fields: [
        {
          'PROFESSIONE_ATTIVITA-PROFESSIONE': {
            fieldName: 'professione'
          }
        }
      ]
    },
    fetch: {
      questionario: {
        url: 'wgt/ar/getQuestionario',//'wgt/acol/get',
        body: {
          contesto:'ACOLProspect_PF',
          viewMode: false
        },
        fields: [
          {
            'PROFESSIONE_ATTIVITA-PROFESSIONE': {
              fieldName: 'profession'
            }
          },
          {
            'PROFESSIONE_ATTIVITA-ATTIVITA': {
              fieldName: 'attivita'
            }
          },
          {
            'PROFESSIONE_ATTIVITA-ATTIVITA': {
              fieldName: 'attivitaEconomica'
            }
          }
        ],
        mappingEvent: 'questionario'
      }
    },
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.filled,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
    // trigger: [
    //   {
    //     componentId: 'PROFESSIONE_ATTIVITA-ATTIVITA',
    //     type: 'fetch'
    //   }
    // ]
  },

  'PROFILAZIONE-VISIONE': {
    name: 'VISIONE',
    type: 'checkbox',
    cleanName: 'Profilazione visione',
    // validations: {
    //   isRequired: true,
    //   default: [
    //     {
    //       validate: VALIDATION_METHODS.bool,
    //       getErrorMessage: VALIDATION_ERRORS.filled
    //     }
    //   ]
    // },
    description:
      //'Ti chiediamo il consenso per il trattamento dei tuoi dati per l\'offerta di prodotti finanziari del Gruppo Sella, per la gestione o/e il monitoraggio dei movimenti, anche ai fini antifrode, o per la realizzazione e l\'invio di promozioni ed offerte create "su misura" per te, sia direttamente che tramite società terze.'
      'Consenso facoltativo al trattamento dei dati personali per finalità di profilazione.\nCon riferimento al Paragrafo 9 dell’informativa, mi esprimo in merito al trattamento dei miei dati da parte di Axerve ai fini di seguito indicati, consapevole che tale azione è facoltativa e non vincolante alla stipula del contratto:attività di profilazione per proporLe prodotti e servizi personalizzati che rispondono al meglio alle Sue esigenze.'
  },
  'PROMOZIONE-VISIONE': {
    name: 'VISIONE',
    type: 'checkbox',
    cleanName: 'Presa visione',
    // validations: {
    //   isRequired: true,
    //   default: [
    //     {
    //       validate: VALIDATION_METHODS.bool,
    //       getErrorMessage: VALIDATION_ERRORS.filled
    //     }
    //   ]
    // },
    description:
      //'Ti chiediamo il consenso per il trattamento dei tuoi dati da parte di Axerve S.p.A., da parte di una Società del Gruppo Sella oppure da parte di società terze nominate responsabili esterne del trattamento per l\'offerta di prodotti finanziari del Gruppo Sella e prodotti e servizi di terzi, per la gestione o/e il monitoraggio dei movimenti, anche ai fini antifrode, o per la realizzazione e l\'invio di promozioni ed offerte create "su misura" per te, sia direttamente che tramite società terze.'
      'Rilevazione del grado di soddisfazione della Clientela sulla qualità dei servizi resi, elaborazione di studi e ricerche di mercato, attività di marketing di prodotti e servizi propri, di Società del Gruppo Banca Sella o di terzi, per migliorare continuamente il servizio fornito.'
  },
  'PROMOZIONE_TERZI-VISIONE': {
    name: 'VISIONE',
    type: 'checkbox',
    cleanName: 'Presa visione',
    // validations: {
    //   isRequired: true,
    //   default: [
    //     {
    //       validate: VALIDATION_METHODS.bool,
    //       getErrorMessage: VALIDATION_ERRORS.filled
    //     }
    //   ]
    // },
    description:
      //'Per dar seguito alla richiesta è necessario il tuo consenso alla comunicazione dei dati a soggetti terzi che svolgono per conto della banca attività di promozione/vendita di prodotti/servizi, rilevazione del grado di soddisfazione della clientela, ricerche di mercato.'
      'Comunicazione dei dati a soggetti terzi che svolgono per conto di Axerve attività di rilevazione del grado di soddisfazione della Clientela sulla qualità dei servizi resi, elaborazione di studi e ricerche di mercato, attività di marketing di prodotti e servizi propri, di Società del Gruppo Banca Sella o di terzi, per migliorare continuamente il servizio fornito ai Clienti.'
  },
  'RESIDENZA-NAZIONE': {
    name: 'NAZIONE',
    type: 'text',
    isDisabled: true,
    value: 'ITALIA',
    cleanName: 'Nazione'
    // type: 'selectbox',
    // cleanName: 'Nazione',
    // value: 'ITALIA',
    // isDisabled: true,
    // position: 1,
    // options: {
    //   url: 'wgt/utils/nazionifromegon',
    //   mapping: { label: 'nome', value: 'nome' }
    // }
  },
  'RESIDENZA-CAP': {
    name: 'CAP',
    type: 'text',
    cleanName: 'CAP',
    position: 1,
    autofill: {
      url: 'wgt/utils/dettaglicapfromegon',
      errorMessage: 'il CAP non è valido',
      mapping: [
        {
          key: 'capCode',
          componentId: 'RESIDENZA-CAP'
        },
        // {
        //   key: 'stato',
        //   componentId: 'RESIDENZA-NAZIONE'
        // },
        {
          key: 'provincia',
          componentId: 'RESIDENZA-PROVINCIA'
        },
        {
          key: 'localita',
          componentId: 'RESIDENZA-CITTA'
        }
      ]
    },
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.cap,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'RESIDENZA-PROVINCIA': {
    name: 'PROVINCIA',
    type: 'selectbox',
    cleanName: 'Provincia',
    //isDisabled: true,
    position: 2,
    // autofill: {
    //   url: 'wgt/utils/comunifromegon',
    //   errorMessage: 'la provincia non è valida',
    //   mapping: [
    //     {
    //       key: 'provincia',
    //       componentId: 'RESIDENZA-PROVINCIA'
    //     },
    //     {
    //       key: 'localita',
    //       componentId: 'RESIDENZA-CITTA',
    //       excludeFromPayload: true
    //     },
    //     {
    //       key: 'capCode',
    //       componentId: 'RESIDENZA-CAP',
    //       excludeFromPayload: true
    //     }
    //   ]
    // },
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.alphabetic,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    options: {
      url: 'wgt/utils/provincefromegon',
      mapping: { label: 'sigla', value: 'sigla' },
      fields: [
        {
          'RESIDENZA-NAZIONE': {
            fieldName: 'nome'
          }
        }
      ]
    },
    notifyComponents: {
      validate: ['RESIDENZA-INDIRIZZO']
    },
    flag: 'static_1'
  },
  'RESIDENZA-CITTA': {
    name: 'CITTA',
    type: 'selectbox',
    isDisabled: true,
    cleanName: 'Città',
    position: 3,
    options: {
      // url: 'wgt/utils/comunifromegon',
      mapping: { label: 'localita', value: 'localita' },
      fields: [
        {
          'RESIDENZA-PROVINCIA': {
            fieldName: 'provincia'
          }
        }
      ]
    },
    autofill: {
      mapping: [
        {
          key: 'localita',
          resKey: 'provincia',
          componentId: 'RESIDENZA-PROVINCIA'
        }
      ]
    },
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.city,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    notifyComponents: {
      validate: ['RESIDENZA-INDIRIZZO']
    }
  },
  'RESIDENZA-INDIRIZZO': {
    name: 'INDIRIZZO',
    type: 'text',
    cleanName: 'Indirizzo e numero civico',
    modalTitle: "Verifica l'indirizzo di residenza",
    position: 4,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.address,
          getErrorMessage: VALIDATION_ERRORS.address
        }
      ]
      // url: 'wgt/validate/indirizzo',
      // lazy: true,
      // fields: [
      //   'RESIDENZA-NAZIONE',
      //   'RESIDENZA-PROVINCIA',
      //   'RESIDENZA-CAP',
      //   'RESIDENZA-CITTA',
      //   'RESIDENZA-INDIRIZZO',
      //   'RESIDENZA-INDIRIZZO_TIPO'
      // ],
      // mapping: {
      //   'RESIDENZA-CAP': 'cap',
      //   'RESIDENZA-NAZIONE': 'nazione',
      //   'RESIDENZA-PROVINCIA': 'provincia',
      //   'RESIDENZA-CITTA': 'citta',
      //   'RESIDENZA-INDIRIZZO': 'indirizzo',
      //   'RESIDENZA-INDIRIZZO_TIPO': 'tipoIndirizzo'
      // }
    },
    hint: {
      value: HINTS.address,
      visible: false
    }
  },
  'RESIDENZA-INDIRIZZO_TIPO': {
    id: 'RESIDENZA-INDIRIZZO_TIPO',
    name: 'INDIRIZZO_TIPO',
    type: 'hidden',
    value: 'IRE',
    status: [],
    extra: true
  },
  'RESIDENZA_FISCALE-NAZIONE': {
    name: 'NAZIONE',
    type: 'selectbox',
    value: 'ITALIA',
    cleanName: 'Nazione',
    options: {
      url: 'wgt/utils/nazionifromegon',
      mapping: { label: 'nome', value: 'nome' }
    }
  },
  'RESIDENZA_FISCALE-NAZIONE_2': {
    name: 'NAZIONE_2',
    type: 'selectbox',
    cleanName: 'Nazione',
    options: {
      url: 'wgt/utils/nazionifromegon',
      mapping: { label: 'nome', value: 'nome' }
    }
  },
  'RESIDENZA_FISCALE-NAZIONE_3': {
    name: 'NAZIONE_3',
    type: 'selectbox',
    cleanName: 'Nazione',
    options: {
      url: 'wgt/utils/nazionifromegon',
      mapping: { label: 'nome', value: 'nome' }
    }
  },
  'RESIDENZA_FISCALE-NO_ALTRE_RESIDENZE': {
    name: 'NO_ALTRE_RESIDENZE',
    cleanName: 'Nessuna altra residenza'
  },
  'RESIDENZA_FISCALE-CF_3': {
    name: 'CF_3',
    type: 'text',
    cleanName: 'Codice Fiscale',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.cf,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ],
      url: 'wgt/validate/codicefiscale',
      fields: [
        'RESIDENZA_FISCALE-CF_3',
        'RESIDENZA_FISCALE-NOME',
        'RESIDENZA_FISCALE-COGNOME'
      ]
    }
  },
  'RESIDENZA_FISCALE-CF_2': {
    name: 'CF_2',
    type: 'text',
    cleanName: 'Codice Fiscale',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.cf,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ],
      url: 'wgt/validate/codicefiscale',
      fields: [
        'RESIDENZA_FISCALE-CF_2',
        'RESIDENZA_FISCALE-NOME',
        'RESIDENZA_FISCALE-COGNOME'
      ]
    }
  },
  'RESIDENZA_FISCALE-STESSA_NAZIONE': {
    name: 'STESSA_NAZIONE',
    cleanName: 'Stessa nazione'
  },
  'RESIDENZA_FISCALE-ALTRE_RESIDENZE': {
    name: 'ALTRE_RESIDENZE',
    cleanName: 'Altre residenze'
  },
  'RESIDENZA_FISCALE-ALTRA_NAZIONE': {
    name: 'ALTRA_NAZIONE',
    cleanName: 'Altra nazione'
  },
  'RESIDENZA_FISCALE-CF': {
    name: 'CF',
    type: 'text',
    cleanName: 'Codice Fiscale',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.cf,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ],
      url: 'wgt/validate/codicefiscale',
      fields: [
        'RESIDENZA_FISCALE-CF',
        'RESIDENZA_FISCALE-NOME',
        'RESIDENZA_FISCALE-COGNOME'
      ]
    }
  },
  'RESUME_BY_CELL-PREF_CELLULARE': {
    name: 'PREF_CELLULARE',
    type: 'hidden',
    value: '+39',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.mobilePrefix,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
    // type: 'selectbox',
    // isDisabled: true,
    // options: {
    //   url: 'wgt/utils/prefissi',
    //   mapping: { label: 'description', value: 'value' }
    // },
    // value: '+39',
    // cleanName: 'Prefisso cellulare',
    // validations: {
    //   isRequired: true
    // }
  },
  'RESUME_BY_CELL-NUM_CELLULARE': {
    name: 'NUM_CELLULARE',
    type: 'text',
    cleanName: 'Numero cellulare',
    isDisabled: true,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.mobileNumber,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'RESUME_BY_CELL-CODICE_CELLULARE': {
    name: 'CODICE_CELLULARE',
    type: 'text',
    // status: ['hidden'],
    cleanName: 'Codice OTP',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.otp,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'RESUME_BY_CELL-GUID_PROCESSO': {
    name: 'GUID_PROCESSO',
    type: 'hidden',
    cleanName: 'GUID del processo'
  },
  'RIF_POSTALE-ALTRO': {
    name: 'ALTRO',
    cleanName: 'Altro'
  },
  'RIF_POSTALE-RESIDENZA': {
    name: 'RESIDENZA',
    type: 'text',
    cleanName: 'Residenza'
  },
  'RIF_POSTALE-PROVINCIA': {
    name: 'PROVINCIA',
    type: 'selectbox',
    cleanName: 'Provincia',
    options: {
      url: 'wgt/utils/provincefromegon',
      mapping: { label: 'sigla', value: 'sigla' },
      fields: [
        {
          'RIF_POSTALE-NAZIONE': {
            fieldName: 'nome'
          }
        }
      ]
    }
  },
  'RIF_POSTALE-NAZIONE': {
    name: 'NAZIONE',
    type: 'selectbox',
    cleanName: 'Nazione',
    options: {
      url: 'wgt/utils/nazionifromegon',
      mapping: { label: 'nome', value: 'nome' }
    }
  },
  'RIF_POSTALE-INDIRIZZO': {
    name: 'INDIRIZZO',
    type: 'text',
    cleanName: 'Indirizzo e numero civico',
    modalTitle: "Verifica l'indirizzo di spedizione",
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.address,
          getErrorMessage: VALIDATION_ERRORS.address
        }
      ]
      // url: 'wgt/validate/indirizzo',
      // lazy: true,
      // fields: [
      //   'RIF_POSTALE-NAZIONE',
      //   'RIF_POSTALE-PROVINCIA',
      //   'RIF_POSTALE-CAP',
      //   'RIF_POSTALE-CITTA',
      //   'RIF_POSTALE-INDIRIZZO',
      //   'RIF_POSTALE-INDIRIZZO_TIPO'
      // ],
      // mapping: {
      //   'RIF_POSTALE-CAP': 'cap',
      //   'RIF_POSTALE-NAZIONE': 'nazione',
      //   'RIF_POSTALE-PROVINCIA': 'provincia',
      //   'RIF_POSTALE-CITTA': 'citta',
      //   'RIF_POSTALE-INDIRIZZO': 'indirizzo',
      //   'RIF_POSTALE-INDIRIZZO_TIPO': 'tipoIndirizzo'
      // }
    }
  },
  'RIF_POSTALE-DOMICILIO': {
    name: 'DOMICILIO',
    type: 'text',
    cleanName: 'Domicilio'
  },
  'RIF_POSTALE-CITTA': {
    name: 'CITTA',
    type: 'selectbox',
    isDisabled: true,
    cleanName: 'Città',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.city,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'RIF_POSTALE-CAP': {
    name: 'CAP',
    type: 'text',
    cleanName: 'CAP',
    autofill: {
      url: 'wgt/utils/dettaglicapfromegon',
      errorMessage: 'il CAP non è valido',
      mapping: [
        {
          key: 'capCode',
          componentId: 'RIF_POSTALE-CAP'
        },
        // {
        //   key: 'stato',
        //   componentId: 'RIF_POSTALE-NAZIONE'
        // },
        {
          key: 'provincia',
          componentId: 'RIF_POSTALE-PROVINCIA'
        },
        {
          key: 'localita',
          componentId: 'RIF_POSTALE-CITTA'
        }
      ]
    },
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.cap,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'RIF_SPEDIZIONE_CARTA-ALTRO': {
    name: 'ALTRO',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    cleanName: 'Presso un altro indirizzo',
    position: 3,
    toggleVisibility: {
      show: {
        fields: [
          'RIF_SPEDIZIONE_CARTA-NAZIONE',
          'RIF_SPEDIZIONE_CARTA-PROVINCIA',
          'RIF_SPEDIZIONE_CARTA-CITTA',
          'RIF_SPEDIZIONE_CARTA-CAP',
          'RIF_SPEDIZIONE_CARTA-INDIRIZZO'
        ]
      }
    }
  },
  'RIF_SPEDIZIONE_CARTA-RADIO_SPACER': {
    id: 'RIF_SPEDIZIONE_CARTA-RADIO_SPACER',
    name: 'RADIO_SPACER',
    type: 'spacer',
    position: 4,
    value: '',
    status: [],
    extra: true
  },
  'RIF_SPEDIZIONE_CARTA-CAP': {
    name: 'CAP',
    type: 'text',
    cleanName: 'CAP',
    position: 5,
    autofill: {
      url: 'wgt/utils/dettaglicapfromegon',
      errorMessage: 'il CAP non è valido',
      mapping: [
        {
          key: 'capCode',
          componentId: 'RIF_SPEDIZIONE_CARTA-CAP'
        },
        // {
        //   key: 'stato',
        //   componentId: 'RIF_SPEDIZIONE_CARTA-NAZIONE'
        // },
        {
          key: 'provincia',
          componentId: 'RIF_SPEDIZIONE_CARTA-PROVINCIA'
        },
        {
          key: 'localita',
          componentId: 'RIF_SPEDIZIONE_CARTA-CITTA'
        }
      ]
    },
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.cap,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'RIF_SPEDIZIONE_CARTA-CITTA': {
    name: 'CITTA',
    type: 'selectbox',
    isDisabled: true,
    cleanName: 'Città',
    position: 7,
    options: {
      // url: 'wgt/utils/comunifromegon',
      mapping: { label: 'localita', value: 'localita' },
      fields: [
        {
          'RIF_SPEDIZIONE_CARTA-PROVINCIA': {
            fieldName: 'provincia'
          }
        }
      ]
    },
    autofill: {
      mapping: [
        {
          key: 'localita',
          resKey: 'provincia',
          componentId: 'RIF_SPEDIZIONE_CARTA-PROVINCIA'
        }
      ]
    },
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.city,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    notifyComponents: {
      validate: ['RIF_SPEDIZIONE_CARTA-INDIRIZZO']
    }
  },
  'RIF_SPEDIZIONE_CARTA-DOMICILIO': {
    name: 'DOMICILIO',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    cleanName: 'Presso il mio domicilio',
    position: 2,
    toggleVisibility: {
      hide: {
        fields: [
          'RIF_SPEDIZIONE_CARTA-NAZIONE',
          'RIF_SPEDIZIONE_CARTA-PROVINCIA',
          'RIF_SPEDIZIONE_CARTA-CITTA',
          'RIF_SPEDIZIONE_CARTA-CAP',
          'RIF_SPEDIZIONE_CARTA-INDIRIZZO'
        ]
      }
    }
  },
  'RIF_SPEDIZIONE_CARTA-INDIRIZZO': {
    name: 'INDIRIZZO',
    type: 'text',
    cleanName: 'Indirizzo e numero civico',
    modalTitle: "Verifica l'indirizzo di spedizione",
    position: 8,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.address,
          getErrorMessage: VALIDATION_ERRORS.address
        }
      ]
      // url: 'wgt/validate/indirizzo',
      // lazy: true,
      // fields: [
      //   'RIF_SPEDIZIONE_CARTA-NAZIONE',
      //   'RIF_SPEDIZIONE_CARTA-PROVINCIA',
      //   'RIF_SPEDIZIONE_CARTA-CAP',
      //   'RIF_SPEDIZIONE_CARTA-CITTA',
      //   'RIF_SPEDIZIONE_CARTA-INDIRIZZO',
      //   'RIF_SPEDIZIONE_CARTA-INDIRIZZO_TIPO'
      // ],
      // mapping: {
      //   'RIF_SPEDIZIONE_CARTA-CAP': 'cap',
      //   'RIF_SPEDIZIONE_CARTA-NAZIONE': 'nazione',
      //   'RIF_SPEDIZIONE_CARTA-PROVINCIA': 'provincia',
      //   'RIF_SPEDIZIONE_CARTA-CITTA': 'citta',
      //   'RIF_SPEDIZIONE_CARTA-INDIRIZZO': 'indirizzo',
      //   'RIF_SPEDIZIONE_CARTA-INDIRIZZO_TIPO': 'tipoIndirizzo'
      // }
    },
    hint: {
      value: HINTS.address,
      visible: false
    }
  },
  'RIF_SPEDIZIONE_CARTA-INDIRIZZO_TIPO': {
    id: 'RIF_SPEDIZIONE_CARTA-INDIRIZZO_TIPO',
    name: 'INDIRIZZO_TIPO',
    type: 'hidden',
    value: 'IRE',
    status: [],
    extra: true
  },
  'RIF_SPEDIZIONE_CARTA-NAZIONE': {
    name: 'NAZIONE',
    type: 'hidden',
    value: 'ITALIA'
    // type: 'selectbox',
    // value: 'ITALIA',
    // cleanName: 'Nazione',
    // position: 3,
    // isDisabled: true,
    // options: {
    //   url: 'wgt/utils/nazionifromegon',
    //   mapping: { label: 'nome', value: 'nome' }
    // }
  },
  'RIF_SPEDIZIONE_CARTA-PROVINCIA': {
    name: 'PROVINCIA',
    type: 'selectbox',
    cleanName: 'Provincia',
    isDisabled: true,
    position: 6,
    // autofill: {
    //   url: 'wgt/utils/comunifromegon',
    //   errorMessage: 'la provincia non è valida',
    //   mapping: [
    //     {
    //       key: 'provincia',
    //       componentId: 'RIF_SPEDIZIONE_CARTA-PROVINCIA'
    //     },
    //     {
    //       key: 'localita',
    //       componentId: 'RIF_SPEDIZIONE_CARTA-CITTA',
    //       excludeFromPayload: true
    //     },
    //     {
    //       key: 'capCode',
    //       componentId: 'RIF_SPEDIZIONE_CARTA-CAP',
    //       excludeFromPayload: true
    //     }
    //   ]
    // },
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.alphabetic,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    options: {
      url: 'wgt/utils/provincefromegon',
      mapping: { label: 'sigla', value: 'sigla' },
      fields: [
        {
          'RIF_SPEDIZIONE_CARTA-NAZIONE': {
            fieldName: 'nome'
          }
        }
      ]
    },
    notifyComponents: {
      validate: ['RIF_SPEDIZIONE_CARTA-INDIRIZZO']
    }
  },
  'RIF_SPEDIZIONE_CARTA-RESIDENZA': {
    name: 'RESIDENZA',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    cleanName: 'Presso la mia residenza',
    position: 1,
    toggleVisibility: {
      hide: {
        fields: [
          'RIF_SPEDIZIONE_CARTA-NAZIONE',
          'RIF_SPEDIZIONE_CARTA-PROVINCIA',
          'RIF_SPEDIZIONE_CARTA-CITTA',
          'RIF_SPEDIZIONE_CARTA-CAP',
          'RIF_SPEDIZIONE_CARTA-INDIRIZZO'
        ]
      }
    }
  },
  'SELFIE-SELFIE_UPLOAD': {
    name: 'SELFIE_UPLOAD',
    type: 'file',
    position: 3,
    uploadType: 'SELFIE',
    cleanName: 'Scatta un selfie con documento in mano',
    modalTitle: 'Scatta il tuo selfie con documento in mano',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.filled,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'SELFIE-SELFIE_UPLOAD_LABEL': {
    id: 'SELFIE-SELFIE_UPLOAD_LABEL',
    name: 'SELFIE_UPLOAD_LABEL',
    type: 'label',
    isPadded: true,
    isCentered: true,
    position: 2,
    value:
      'Scatta un <b>selfie</b> con un <b>tuo documento</b> in mano.<br>Assicurati che sia il tuo <b>viso</b> che il <b>documento</b> siano <b>ben riconoscibili</b> nella foto.',
    status: [],
    extra: true
  },
  'SELFIE-SELFIE_UPLOAD_SPACER': {
    id: 'SELFIE-SELFIE_UPLOAD_SPACER',
    name: 'SELFIE_UPLOAD_SPACER',
    type: 'spacer',
    position: 1,
    value: '',
    status: [],
    extra: true
  },
  'SUCCURSALE-SUCCURSALE': {
    name: 'SUCCURSALE',
    cleanName: 'Succursale'
  },
  'SUCCURSALE_IDENTIFICAZIONE-TIPO_DOCUMENTO': {
    name: 'TIPO_DOCUMENTO',
    type: 'selectbox',
    options: {
      url: 'wgt/utils/documenti',
      mapping: { label: 'nome', value: 'nome' }
    },
    cleanName: 'Tipo di documento'
  },
  'SUCCURSALE_IDENTIFICAZIONE-LUOGO_RILASCIO': {
    name: 'LUOGO_RILASCIO',
    type: 'text',
    cleanName: 'Luogo di rilascio'
  },
  'SUCCURSALE_IDENTIFICAZIONE-NUMERO_DOCUMENTO': {
    name: 'NUMERO_DOCUMENTO',
    type: 'text',
    cleanName: 'Numero documento'
  },
  'SUCCURSALE_IDENTIFICAZIONE-SUCCURSALE': {
    name: 'SUCCURSALE',
    cleanName: 'Succursale'
  },
  'SUCCURSALE_IDENTIFICAZIONE-DATA_SCADENZA': {
    name: 'DATA_SCADENZA',
    type: 'text',
    cleanName: 'Data scadenza',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.date,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'SUCCURSALE_IDENTIFICAZIONE-DATA_RILASCIO': {
    name: 'DATA_RILASCIO',
    type: 'text',
    cleanName: 'Data rilascio',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.date,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'SUCCURSALE_IDENTIFICAZIONE-ENTE_RILASCIO': {
    name: 'ENTE_RILASCIO',
    type: 'text',
    cleanName: 'Ente di rilascio'
  },
  /*  'TERMINA_PROCEDURA-LABEL': {
     name: 'LABEL',
     type: 'label',
     cleanName: 'Label',
     value: 'Per completare la tua richiesta manca pochissimo!'
   },
   'TERMINA_PROCEDURA-RESUME_INTEST_2': {
     name: 'RESUME_INTEST_2',
     type: null,
     cleanName: 'Riprendi in test'
   },
   'TERMINA_PROCEDURA-RESUME_INTEST_3': {
     name: 'RESUME_INTEST_3',
     type: null,
     cleanName: 'Riprendi in test'
   }, */
  'TIPOLOGIA_CARTA-CARTA_FISICA': {
    name: 'CARTA_FISICA',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    cleanName: 'Voglio ricevere GRATIS anche la carta fisica',
    description:
      'Per acquistare online, nei negozi e prelevare contanti in tutto il mondo senza commissioni.',
    // value: '',
    position: 1,
    toggleVisibility: {
      show: {
        fields: [
          'RIF_SPEDIZIONE_CARTA' /*,
          'RIF_SPEDIZIONE_CARTA-RESIDENZA',
          'RIF_SPEDIZIONE_CARTA-DOMICILIO',
          'RIF_SPEDIZIONE_CARTA-ALTRO'*/
        ]
      }
    }
  },
  'TIPOLOGIA_CARTA-CARTA_VIRTUALE': {
    name: 'CARTA_VIRTUALE',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    cleanName: 'Voglio solo la carta virtuale',
    description:
      'Permette di effettuare soltanto acquisti online e non consente prelievi di denaro.',
    position: 2,
    toggleVisibility: {
      hide: {
        fields: [
          'RIF_SPEDIZIONE_CARTA' /*,
          'RIF_SPEDIZIONE_CARTA-RESIDENZA',
          'RIF_SPEDIZIONE_CARTA-DOMICILIO',
          'RIF_SPEDIZIONE_CARTA-ALTRO'*/
        ]
      }
    }
  },
  'VERIFICA_DATI_DA_CF-CF': {
    name: 'CF',
    type: 'text',
    cleanName: 'Codice Fiscale',
    isDisabled: true,
    position: 7
    // validations: {
    //   isRequired: true,
    //   default: [
    //     {
    //       validate: VALIDATION_METHODS.cf,
    //       getErrorMessage: VALIDATION_ERRORS.filled
    //     }
    //   ],
    //   url: 'wgt/validate/codicefiscale',
    //   fields: [
    //     'VERIFICA_DATI_DA_CF-CF',
    //     'VERIFICA_DATI_DA_CF-NOME',
    //     'VERIFICA_DATI_DA_CF-COGNOME'
    //   ]
    // }
  },
  'VERIFICA_DATI_DA_CF-CITTA': {
    name: 'CITTA',
    type: 'text',
    cleanName: 'Città',
    isDisabled: true,
    position: 5
    // validations: {
    //   isRequired: true,
    //   default: [
    //     {
    //       validate: VALIDATION_METHODS.city,
    //       getErrorMessage: VALIDATION_ERRORS.filled
    //     }
    //   ]
    // }
  },
  'VERIFICA_DATI_DA_CF-COGNOME': {
    name: 'COGNOME',
    type: 'text',
    cleanName: 'Cognome',
    isDisabled: true,
    position: 2
    // validations: {
    //   isRequired: true,
    //   default: [
    //     {
    //       validate: VALIDATION_METHODS.alphabetic,
    //       getErrorMessage: VALIDATION_ERRORS.filled
    //     }
    //   ]
    // }
  },
  'VERIFICA_DATI_DA_CF-DATA': {
    name: 'DATAb',
    type: 'text',
    cleanName: 'Data',
    isDisabled: true,
    position: 3
    // validations: {
    //   isRequired: true,
    //   default: [
    //     {
    //       validate: VALIDATION_METHODS.date,
    //       getErrorMessage: VALIDATION_ERRORS.filled
    //     }
    //   ]
    // }
  },
  'VERIFICA_DATI_DA_CF-NOME': {
    name: 'NOME',
    type: 'text',
    cleanName: 'Nome',
    isDisabled: true,
    position: 1
    // validations: {
    //   isRequired: true,
    //   default: [
    //     {
    //       validate: VALIDATION_METHODS.alphabetic,
    //       getErrorMessage: VALIDATION_ERRORS.filled
    //     }
    //   ]
    // }
  },
  'VERIFICA_DATI_DA_CF-PROVINCIA': {
    name: 'PROVINCIA',
    type: 'text',
    cleanName: 'Provincia',
    isDisabled: true,
    position: 6
    // options: {
    //   url: 'wgt/utils/provincefromegon',
    //   mapping: { label: 'sigla', value: 'sigla' },
    //   fields: [
    //     {
    //       'VERIFICA_DATI_DA_CF-NAZIONE': {
    //         fieldName: 'nome'
    //       }
    //     }
    //   ]
    // }
  },
  'VERIFICA_DATI_DA_CF-SESSO': {
    name: 'SESSO',
    type: 'text',
    cleanName: 'Sesso',
    isDisabled: true,
    position: 4
    // values: ['M', 'F']
  },
  'WIDGET_HTML-HTML': {
    name: 'HTML',
    cleanName: 'Html'
  },
  /* 'TERMINA_PROCEDURA-CONTRATTO': {
    id: 'TERMINA_PROCEDURA-CONTRATTO',
    name: 'CONTRATTO',
    type: 'labelWithLink',
    status: [],
    // validations: {
    //   isRequired: true,
    //   default: [{validate:V(v) => ALIDATION_PATTERNS.bool.test(c.value)}]
    // },
    link: {
      placeholder: '§link§',
      text: 'contratto',
      dataSourceUrl: 'wgt/sign/contractlist'
    },
    acknowledgement: {
      url: 'wgt/utils/presavisione',
      fields: ''
    },
    cleanName: 'Presa visione',
    value:
      'Proseguendo dichiaro di aver letto e accettato il §link§ ed attesto di essere fiscalmente residente esclusivamente in Italia (*)',
    extra: true
  },
  'TERMINA_PROCEDURA-MODULO': {
    id: 'TERMINA_PROCEDURA-MODULO',
    name: 'MODULO',
    type: 'labelWithLink',
    status: [],
    // validations: {
    //   isRequired: true,
    //   default: [{validate:V(v) => ALIDATION_PATTERNS.bool.test(c.value)}]
    // },
    link: {
      placeholder: '§link§',
      text: 'modulo standard',
      url:
        'https://www.hype.it/SSRDocumentDisplayer?dtdPG=INFO_DEPOSITANTI_BSE&dtdPE=1'
    },
    cleanName: 'Presa visione',
    value:
      'Dichiaro di aver inoltre ricevuto, prima della conclusione del contratto, il §link§ per le informazioni da fornire ai depositanti',
    extra: true
  },
  'TERMINA_PROCEDURA-RESIDENZA_ITA': {
    id: 'TERMINA_PROCEDURA-RESIDENZA_ITA',
    name: 'RESIDENZA_ITA',
    type: 'labelWithLink',
    status: [],
    // validations: {
    //   isRequired: true,
    //   default: [{validate:V(v) => ALIDATION_PATTERNS.bool.test(c.value)}]
    // },
    links: [
      {
        placeholder: '§link§',
        text: 'cliccando qui',
        url: '#'
      }
      // ,
      // {
      //   placeholder: '§phone§',
      //   text: '0152434667',
      //   url: 'phone:0152434667'
      // }
    ],
    cleanName: 'Presa visione',
    value:
      'Nel caso tu abbia altre residenze fiscali oltre a quella italiana scrivici §link§', //contattaci telefonicamente allo §phone§ oppure
    extra: true
  },
  'TERMINA_PROCEDURA-RESIDENZA_ITA_SPEC': {
    id: 'TERMINA_PROCEDURA-RESIDENZA_ITA_SPEC',
    name: 'RESIDENZA_ITA_SPEC',
    type: 'label',
    status: [],
    cleanName: 'Presa visione',
    isSmall: true,
    value:
      '(*)"Attestazione di residenza fiscale resa ai sensi dell\'art. 5 della Legge 95/2015 e del DPCM 28/12/2015 (G.U. n° 303 del 31/12/2015) art. 2 comma 1 e Allegato A sezione III A"',
    extra: true
  },*/
  'JOLLY-LABEL': {
    id: 'JOLLY-LABEL',
    name: 'LABEL',
    type: 'hidden'
  },
  'JOLLY-SUB_LABEL': {
    id: 'JOLLY-SUB_LABEL',
    name: 'SUB_LABEL',
    type: 'label',
    value:
      "A seguito della richiesta che ho ricevuto tramite e-mail, autorizzo e richiedo l'attivazione del servizio Hype intestato al soggetto minorenne richiedente, del quale dichiaro di essere:",
    position: 1
  },
  'JOLLY-JOLLY_INPUT': {
    id: 'JOLLY-JOLLY_INPUT',
    name: 'JOLLY_INPUT',
    type: 'hidden'
  },
  'JOLLY-JOLLY_SPACER': {
    id: 'JOLLY-JOLLY_SPACER',
    name: 'JOLLY_SPACER',
    type: 'spacer',
    position: 2,
    value: '',
    status: [],
    extra: true
  },
  'JOLLY-JOLLY_RADIO_GENITORE': {
    id: 'JOLLY-JOLLY_RADIO_GENITORE',
    name: 'JOLLY_RADIO_GENITORE',
    type: 'radio',
    position: 3,
    cleanName: 'Genitore',
    value: '',
    values: [
      { value: 'GENITORE', selected: 'selected' },
      { value: 'TUTORE', selected: '' },
      { value: 'selected', selected: '', rif: 'selected' },
      { value: 'selected', selected: '', rif: '' }
    ],
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    autofill: {
      mapping: [
        {
          componentId: 'JOLLY-JOLLY_INPUT',
          key: 'selected'
        },
        {
          componentId: 'RIF_SPEDIZIONE_CARTA-RESIDENZA',
          key: 'rif'
        }
      ]
    },
    status: [],
    extra: true
  },
  'JOLLY-JOLLY_RADIO_TUTORE': {
    id: 'JOLLY-JOLLY_RADIO_TUTORE',
    name: 'JOLLY_RADIO_TUTORE',
    type: 'radio',
    position: 4,
    cleanName: 'Tutore',
    value: '',
    values: [
      { value: 'GENITORE', selected: '' },
      { value: 'TUTORE', selected: 'selected' },
      { value: 'selected', selected: '', rif: 'selected' },
      { value: 'selected', selected: '', rif: '' }
    ],
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    autofill: {
      mapping: [
        {
          componentId: 'JOLLY-JOLLY_INPUT',
          key: 'selected'
        },
        {
          componentId: 'RIF_SPEDIZIONE_CARTA-RESIDENZA',
          key: 'rif'
        }
      ]
    },
    status: [],
    extra: true
  },
  'JOLLY-JOLLY_LABEL2': {
    id: 'JOLLY-JOLLY_LABEL2',
    name: 'JOLLY_LABEL2',
    type: 'label',
    position: 5,
    value:
      'Come genitore/tutore del minorenne riceverai tramite e-mail documentazione periodica delle operazioni effettuate.',
    status: [],
    extra: true
  },
  'WHAT_YOU_NEED-DOCUMENTS': {
    id: 'WHAT_YOU_NEED-DOCUMENTS',
    name: 'DOCUMENTS',
    type: 'image',
    cleanName: 'lorem ipsum',
    position: 1,
    value: 'Tieni a portata di mano un §tuo documento§ di identità',
    values: ['wyn', 'wyn--docs'],
    status: [],
    errorMessage: [],
    extra: true
  },
  'WHAT_YOU_NEED-PHONE': {
    id: 'WHAT_YOU_NEED-PHONE',
    name: 'PHONE',
    type: 'image',
    cleanName: 'lorem ipsum',
    position: 2,
    value: 'Registrati dal tuo smartphone o da pc se hai una §webcam§',
    values: ['wyn', 'wyn--phone'],
    status: [],
    errorMessage: [],
    extra: true
  },
  'WHAT_YOU_NEED-SECURE': {
    id: 'WHAT_YOU_NEED-SECURE',
    name: 'SECURE',
    type: 'image',
    cleanName: 'lorem ipsum',
    position: 3,
    value: 'La registrazione è §rapida e sicura§, sei in buone mani!',
    values: ['wyn', 'wyn--secure'],
    status: [],
    errorMessage: [],
    extra: true
  },
  'WHAT_YOU_NEED-SPACER': {
    id: 'WHAT_YOU_NEED-SPACER',
    name: 'SPACER',
    type: 'spacer',
    position: 4,
    value: '',
    status: [],
    extra: true
  },
  'SIGNALER-HAS_PROMO_CODE_YES': {
    id: 'SIGNALER-HAS_PROMO_CODE_YES',
    name: 'HAS_PROMO_CODE_YES',
    type: 'radio',
    cleanName: 'Ho un codice promo',
    position: 2,
    value: '',
    status: [],
    errorMessage: [],
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    toggleVisibility: {
      show: { fields: ['SIGNALER-PROMO_CODE'] }
    },
    extra: true
  },
  'SIGNALER-HAS_PROMO_CODE_NO': {
    id: 'SIGNALER-HAS_PROMO_CODE_NO',
    name: 'HAS_PROMO_CODE_NO',
    type: 'radio',
    cleanName: 'Non ho un codice promo',
    position: 1,
    value: '',
    status: ['selected'],
    errorMessage: [],
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    toggleVisibility: {
      hide: { fields: ['SIGNALER-PROMO_CODE'] }
    },
    extra: true
  },
  'SIGNALER-PROMO_CODE': {
    id: 'SIGNALER-PROMO_CODE',
    name: 'PROMO_CODE',
    type: 'text',
    cleanName: 'Codice promo',
    position: 3,
    value: '',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.filled,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ],
      url: '../api/rest/FREE/promocode/check',
      method: 'GET',
      fields: ['SIGNALER-PROMO_CODE'],
      mapping: {
        'SIGNALER-PROMO_CODE': 'promocode'
      }
    },
    status: ['hidden'],
    errorMessage: [],
    extra: true
  },
  'SIGNALER-REFERRER': {
    id: 'SIGNALER-REFERRER',
    name: 'REFERRER',
    type: 'hidden',
    position: 2,
    value: '',
    status: [],
    errorMessage: [],
    extra: true
  },
  'SIGNALER-CAMPAIGN_URL': {
    id: 'SIGNALER-CAMPAIGN_URL',
    name: 'CAMPAIGN_URL',
    type: 'hidden',
    position: 3,
    value: '',
    status: [],
    errorMessage: [],
    extra: true
  },
  'VERIFICA_EMAIL_EXTRA-TYPE_VALUE': {
    id: 'VERIFICA_EMAIL_EXTRA-TYPE_VALUE',
    name: 'EMAIL',
    type: 'text',
    cleanName: 'Email',
    position: 1,
    value: '',
    status: [],
    isDisabled: true,
    errorMessage: [],
    extra: true
  },
  'VERIFICA_EMAIL_EXTRA-OTP_VALUE': {
    id: 'VERIFICA_EMAIL_EXTRA-OTP_VALUE',
    name: 'OTP',
    cleanName: 'Codice di verifica',
    type: 'text',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.otpEmail,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ],
      url: '../api/rest/FREE/otp/validate',
      fields: [
        'VERIFICA_EMAIL_EXTRA-REQUEST_ID',
        'VERIFICA_EMAIL_EXTRA-TYPE',
        'VERIFICA_EMAIL_EXTRA-TYPE_VALUE',
        'VERIFICA_EMAIL_EXTRA-OTP_VALUE'
      ],
      mapping: {
        'VERIFICA_EMAIL_EXTRA-REQUEST_ID': 'requestId',
        'VERIFICA_EMAIL_EXTRA-TYPE': 'type',
        'VERIFICA_EMAIL_EXTRA-TYPE_VALUE': 'typeValue',
        'VERIFICA_EMAIL_EXTRA-OTP_VALUE': 'otpValue'
      }
    },
    position: 2,
    value: '',
    status: [],
    errorMessage: [],
    extra: true
  },
  'VERIFICA_EMAIL_EXTRA-LABEL': {
    id: 'VERIFICA_EMAIL_EXTRA-LABEL',
    name: 'LABEL',
    type: 'labelWithLink',
    position: 3,
    link: {
      placeholder: '§link§',
      text: 'Reinvia Otp',
      url: '../api/rest/FREE/otp/send',
      method: 'POST',
      fired: false,
      requestIdComponentId: 'VERIFICA_EMAIL_EXTRA-REQUEST_ID',
      mapping: [
        {
          key: 'templateId',
          componentId: 'VERIFICA_EMAIL_EXTRA-TEMPLATE_ID'
        },
        {
          key: 'type',
          componentId: 'VERIFICA_EMAIL_EXTRA-TYPE'
        },
        {
          key: 'typeValue',
          componentId: 'VERIFICA_EMAIL_EXTRA-TYPE_VALUE'
        }
      ]
    },
    value: `Il CODICE DI VERIFICA è stato inviato
            automaticamente al tuo indirizzo email, se non dovessi
            riceverlo entro un minuto puoi richiederne uno nuovo cliccando
            sul link §link§ o ricaricando la pagina.`,
    status: [],
    errorMessage: [],
    extra: true
  },
  'VERIFICA_EMAIL_EXTRA-TYPE': {
    id: 'VERIFICA_EMAIL_EXTRA-TYPE',
    name: 'OTP_TYPE',
    type: 'hidden',
    position: 3,
    value: 'EMAIL',
    status: [],
    errorMessage: [],
    extra: true
  },
  'VERIFICA_EMAIL_EXTRA-TEMPLATE_ID': {
    id: 'VERIFICA_EMAIL_EXTRA-TEMPLATE_ID',
    name: 'OTP_TEMPLATE',
    type: 'hidden',
    position: 4,
    value: 'TIM_ONBOARD_EMAIL_OTP',
    status: [],
    errorMessage: [],
    extra: true
  },
  'VERIFICA_EMAIL_EXTRA-REQUEST_ID': {
    id: 'VERIFICA_EMAIL_EXTRA-REQUEST_ID',
    name: 'OTP_REQUEST_ID',
    type: 'hidden',
    position: 5,
    value: '',
    status: [],
    errorMessage: [],
    extra: true
  },
  'PARTITA_IVA-NUM_PARTITA_IVA': {
    name: 'NUM_PARTITA_IVA',
    type: 'text',
    cleanName: 'Numero Partita IVA',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.alphanumeric,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ],
      url: 'wgt/validate/piva',
      fields: ['PARTITA_IVA-NUM_PARTITA_IVA'],
      mapping: {
        'PARTITA_IVA-NUM_PARTITA_IVA': 'piva'
      }
    },
    trigger: [
      {
        componentId: 'CF_AZIENDA-NUM_CF_AZIENDA',
        type: 'copy'
      }
    ],
    status: [],
    errorMessage: []
  },
  'CF_AZIENDA-NUM_CF_AZIENDA': {
    name: 'NUM_CF_AZIENDA',
    type: 'text',
    cleanName: 'Codice Fiscale Società'
  },
  'AZIENDA_ROLES-TIPO_ROLES_LINK_AZIENDA': {
    name: 'TIPO_ROLES_LINK_AZIENDA',
    type: 'selectbox',
    cleanName:
      'Scegli tra le cariche disponibili per il tipo di azienda indicato',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.filled,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    values: []
  },
  //step 3:

  'PEC-CODICE_EMAIL': {
    name: 'CODICE_EMAIL',
    type: 'text'
  },
  'PEC-CONFERMA_EMAIL': {
    name: 'CONFERMA_EMAIL',
    type: 'text'
  },
  'PEC-EMAIL': {
    name: 'EMAIL',
    type: 'text',
    cleanName: 'Indirizzo PEC (Posta Elettronica Certificata)',
    position: 1,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.email,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'PEC-ADDRESS': {
    name: 'ADDRESS',
    type: 'label',
    position: 2,
    value: 'L’indirizzo PEC è importante per la ricezione della comunicazione periodica',
  },
  'TELEFONO_FISSO-PREFISSO': {
    name: 'PREFISSO',
    type: 'hidden',
    value: '39',
    active: true,
    position: 1,
    status: ['readonly']
  },
  'TELEFONO_FISSO-NUMERO': {
    name: 'NUMERO',
    type: 'text',
    position: 3,
    cleanName: 'Numero di telefono aziendale',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.mobileNumber,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'SEDE_LEGALE-CAP': {
    name: 'CAP',
    type: 'text',
    position: 1,
    cleanName: 'CAP',
    autofill: {
      url: 'wgt/utils/dettaglicapfromegon',
      errorMessage: 'il CAP non è valido',
      mapping: [
        {
          key: 'capCode',
          componentId: 'SEDE_LEGALE-CAP'
        },
        /*{
          key: 'stato',
          componentId: 'SEDE_LEGALE-NAZIONE'
        },*/
        {
          key: 'provincia',
          componentId: 'SEDE_LEGALE-PROVINCIA'
        },
        {
          key: 'localita',
          componentId: 'SEDE_LEGALE-CITTA'
        }
      ]
    },
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.cap,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'SEDE_LEGALE-PROVINCIA': {
    name: 'PROVINCIA',
    type: 'selectbox',
    position: 2,
    cleanName: 'Provincia',
    isDisabled: false,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.alphabetic,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    options: {
      url: 'wgt/utils/provincefromegon',
      mapping: { label: 'sigla', value: 'sigla' },
      fields: [
        {
          'SEDE_LEGALE-NAZIONE': {
            fieldName: 'value'
          }
        }
      ]
    },
    notifyComponents: {
      validate: ['SEDE_LEGALE-INDIRIZZO']
    },
    flag: 'static_1'
  },
  'SEDE_LEGALE-CITTA': {
    name: 'CITTA',
    type: 'text',
    cleanName: 'Città',
    position: 3,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.city,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'SEDE_LEGALE-NAZIONE': {
    name: 'NAZIONE',
    type: 'text',
    position: 4,
    cleanName: 'Nazione',
    value: 'ITALIA',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.alphabetic,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'SEDE_LEGALE-INDIRIZZO': {
    name: 'INDIRIZZO',
    type: 'text',
    position: 5,
    cleanName: 'Indirizzo e numero civico',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.address,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'SEDE_AMMINISTRATIVA-ALTRO': {
    name: 'ALTRO',
    type: 'radio',
    position: 1,
    cleanName: 'La sede amministrativa NON COINCIDE con la sede legale',
    toggleVisibility: {
      show: {
        fields: [
          'SEDE_AMMINISTRATIVA-CAP',
          'SEDE_AMMINISTRATIVA-CITTA',
          'SEDE_AMMINISTRATIVA-INDIRIZZO',
          'SEDE_AMMINISTRATIVA-NAZIONE',
          'SEDE_AMMINISTRATIVA-PROVINCIA'
        ]
      }
    },
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'SEDE_AMMINISTRATIVA-SEDE_LEGALE': {
    name: 'SEDE_LEGALE',
    type: 'radio',
    position: 1,
    value: 'selected',
    cleanName: 'La sede amministrativa COINCIDE con la sede legale',
    toggleVisibility: {
      hide: {
        fields: [
          'SEDE_AMMINISTRATIVA-CAP',
          'SEDE_AMMINISTRATIVA-CITTA',
          'SEDE_AMMINISTRATIVA-INDIRIZZO',
          'SEDE_AMMINISTRATIVA-NAZIONE',
          'SEDE_AMMINISTRATIVA-PROVINCIA'
        ]
      }
    },
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'SEDE_AMMINISTRATIVA-CAP': {
    name: 'CAP',
    type: 'text',
    cleanName: 'Cap',
    position: 2,
    autofill: {
      url: 'wgt/utils/dettaglicapfromegon',
      errorMessage: 'il CAP non è valido',
      mapping: [
        {
          key: 'capCode',
          componentId: 'SEDE_AMMINISTRATIVA-CAP'
        },
        // {
        //   key: 'stato',
        //   componentId: 'RESIDENZA-NAZIONE'
        // },
        {
          key: 'provincia',
          componentId: 'SEDE_AMMINISTRATIVA-PROVINCIA'
        },
        {
          key: 'localita',
          componentId: 'SEDE_AMMINISTRATIVA-CITTA'
        }
      ]
    },
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.cap,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'SEDE_AMMINISTRATIVA-CITTA': {
    name: 'CITTA',
    type: 'text',
    position: 4,
    cleanName: 'Città',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.city,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'SEDE_AMMINISTRATIVA-INDIRIZZO': {
    name: 'INDIRIZZO',
    type: 'text',
    position: 5,
    cleanName: 'Indirizzo',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.address,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'SEDE_AMMINISTRATIVA-NAZIONE': {
    name: 'NAZIONE',
    type: 'selectbox',
    position: 4,
    cleanName: 'Nazione',
    value: 'ITALIA',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.alphabetic,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    flag: 'static_1'
  },
  'SEDE_AMMINISTRATIVA-PROVINCIA': {
    name: 'PROVINCIA',
    type: 'selectbox',
    position: 3,
    cleanName: 'Provincia',
    options: {
      url: 'wgt/utils/provincefromegon',
      mapping: { label: 'sigla', value: 'sigla' },
      fields: [
        {
          'SEDE_AMMINISTRATIVA-NAZIONE': {
            fieldName: 'value'
          }
        }
      ]
    },
    validations: {
      isRequired: true
    },
    flag: 'static_1'
  },
  'CLASSIFICAZIONE_AZIENDA-FATTURATO_ANNUO': {
    name: 'FATTURATO_ANNUO',
    type: 'text',
    numFormat:'Europian',
    displayType:'input',
    cleanName: 'Fatturato annuo (in Euro)',
    validations: {
       isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.filled,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'CLASSIFICAZIONE_AZIENDA-NUMERO_ADDETTI': {
    name: 'NUMERO_ADDETTI',
    type: 'text',
    cleanName: 'N.Addetti',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.number,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'CLASSIFICAZIONE_AZIENDA-RISULTATO_ECONOMICO': {
    name: 'RISULTATO_ECONOMICO',
    type: 'text',
    numFormat:'Europian',
    displayType:'input',
    cleanName: 'Risultato Economico(perdita/utile)in Euro',
     validations: {
       isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.filled,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
     }
  },
  'CLASSIFICAZIONE_AZIENDA-TOT_BILANCIO_ANNUO': {
    name: 'TOT_BILANCIO_ANNUO',
    type: 'text',
    cleanName: 'Totale Bilancio',
    numFormat:'Europian',
    displayType:'input',
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.filled,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  //step 4:
  'SETTORE_ATTIVITA_AZIENDA-TIPO_SOCIETA': {
    name: 'TIPO_SOCIETA',
    type: 'selectbox',
    cleanName: 'Tipo Attività',
    fullWidth: true,
    isDisabled: false,
    position: 1,
    options: {
      url: 'wgt/utils/tiposocieta',
      mapping: { label: 'description', value: 'value' },
      fields: [
        {
          'SETTORE_ATTIVITA_AZIENDA-TIPO_ID_SOGGETTO': {
            fieldName: 'value'
          }
        }
      ]
    },
    trigger: [
      {
        componentId: 'SETTORE_ATTIVITA_AZIENDA-SETTORE',
        type: 'fetchOption'
      }
    ],
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.filled,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'SETTORE_ATTIVITA_AZIENDA-SETTORE': {
    name: 'SETTORE',
    type: 'selectbox',
    cleanName: 'Settore',
    fullWidth:true,
    position: 2,
    options: {
      url: 'wgt/utils/settoriaziende',
      mapping: { label: 'description', value: 'value' },
      fields: [
        {
          'SETTORE_ATTIVITA_AZIENDA-TIPO_SOCIETA': {
            fieldName: 'idSocieta'
          },
          'SETTORE_ATTIVITA_AZIENDA-TIPO_ID_SOGGETTO': {
            fieldName: 'idSoggetto'
          }
        }
      ]
    },

    fetch: {
      questionario: {
        url: 'wgt/ar/getQuestionarioPG',//'wgt/acol/get/pg',
        body: {
          contesto:'ACOLProspect_PG',
          requestType: 'azienda',
          viewMode: false
        },
        fields: [
          {
            'SETTORE_ATTIVITA_AZIENDA-TIPO_SOCIETA': {
              fieldName: 'tipoSocieta'
            }
          },
          {
            'SETTORE_ATTIVITA_AZIENDA-SETTORE': {
              fieldName: 'sae'
            }
          }
        ],
        mappingEvent: 'questionario'
      }
    },
    trigger: [
      {
        componentId: 'SETTORE_ATTIVITA_AZIENDA-DETTAGLIO_ATTIVITA_ECONOMICA',
        type: 'fetchOption'
      }
      /*,{
        componentId: 'AZIENDA_ANTIRICICLAGGIO-QUESTIONARIO',
        type: 'fetch',
        api: 'questionario'
      }*/
    ],
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.filled,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'SETTORE_ATTIVITA_AZIENDA-DETTAGLIO_ATTIVITA_ECONOMICA': {
    name: 'DETTAGLIO_ATTIVITA_ECONOMICA',
    type: 'selectbox',
    position: 3,
    fullWidth:true,
    /* isDisabled: true, */
    staticDescription: 'Il dato è necessario per finalizzare la compilazione del questionario antiriciclaggio. \nPuoi trovare il codice ATECO della tua attività sulla visura camerale o sul certificato di attribuzione della Partita IVA.',
    cleanName: `Codice ATECO`,
    options: {
      init: true, //acolQuestionnaire widget issue - begin - end
      //init: false,
      /* isDisabled: false, */
      url: 'wgt/utils/dettaglioattivitaaziendepersettore',//dettaglioattivitaaziende',
      mapping: { label: 'description', value: 'value' },
      fields: [
        {
          'SETTORE_ATTIVITA_AZIENDA-SETTORE': {
            fieldName: 'value'
          }
        }
      ]
    },
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.filled,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    }
  },
  'SETTORE_ATTIVITA_AZIENDA-TIPO_ID_SOGGETTO': {
    name: 'TIPO_ID_SOGGETTO',
    type: 'hidden',
    cleanName: ''
  },
  'AZIENDA_ANTIRICICLAGGIO-QUESTIONARIO': {
    name: 'QUESTIONARIO',
    type: 'hidden',
    cleanName: 'Questionario',
    showLoading: true
    /*    fetch: {
      questionario: {
        url: 'wgt/acol/get/pg',
        body: {
          requestType: 'azienda',
          viewMode: false
        },
        fields: [
          {
            'SETTORE_ATTIVITA_AZIENDA-TIPO_SOCIETA': {
              fieldName: 'tipoSocieta'
            }
          },
          {
            'SETTORE_ATTIVITA_AZIENDA-SETTORE': {
              fieldName: 'sae'
            }
          }
        ],
        mappingEvent: 'questionario'
      }
    }*/
  },
  //step 5:

  'TITOLARE_DATA-LABEL': {
    name: 'TITOLARE_DATA-LABEL',
    type: 'label',
    value:
      'OLTRE AD ESSERE LEGALE RAPPRESENTANTE, RISULTO ESSERE ANCHE TITOLARE EFFETTIVO DELLA SOCIETÀ<br/>IL TITOLARE EFFETTIVO POSSIEDE ALMENO IL 25% DELLE QUOTE DELLA SOCIETÀ',
    position: 1
  },
  'TITOLARE_DATA-EFFETTIVO_SI': {
    name: 'EFFETTIVO_SI',
    type: 'radio',
    value: '',
    cleanName: 'SI',
    position: 2,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    toggleVisibility: {
      hide: {
        fields: TITOLARE_EFFETTIVO_WIDGETS
      }
    }
  },
  'TITOLARE_DATA-EFFETTIVO_NO': {
    name: 'EFFETTIVO_NO',
    type: 'radio',
    cleanName: 'NO',
    value: '',
    position: 2,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    toggleVisibility: {
      show: {
        fields: TITOLARE_EFFETTIVO_WIDGETS
      }
    }
  },
  'TITOLARE_OWNER-LABEL': {
    name: 'TITOLARE_OWNER-LABEL',
    type: 'label',
    value:
      'Ci sono altre persone che possiedono almeno il 25% delle quote della società?',
    position: 1
  },
  'TITOLARE_OWNER-EFFETTIVO_SI': {
    name: 'EFFETTIVO_SI',
    type: 'radio',
    value: 'selected',
    cleanName: 'SI',
    position: 2,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    // toggleVisibility: {
    //   hide: {
    //     fields: TITOLARE_EFFETTIVO_WIDGETS
    //   }
    // }
  },
  'TITOLARE_OWNER-EFFETTIVO_NO': {
    name: 'EFFETTIVO_NO',
    type: 'radio',
    cleanName: 'NO',
    value: '',
    position: 2,
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.bool,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    // toggleVisibility: {
    //   show: {
    //     fields: TITOLARE_EFFETTIVO_WIDGETS
    //   }
    // }
  },
  // 'TITOLARE_ESERCITA-LABEL': {
  //   name: 'TITOLARE_DATA-LABEL',
  //   type: 'label',
  //   value:
  //     'ESERCITA O HA ESERCITATO UNA IMPORTANTE FUNZIONE PUBBLICA / POLITICA OPPURE INTRATTIENE LEGAMI (DI PARENTELA O DI AFFARI) CON SOGGETTI CHE ESERCITANO O HANNO ESERCITATO UNA IMPORTANTE FUNZIONE PUBBLICA / POLITICA*'
  // },
  // 'TITOLARE_ESERCITA-ESERCITA_SI': {
  //   name: 'ESERCITA_SI',
  //   type: 'radio',
  //   value: 'selected',
  //   cleanName: 'SI',
  //   position: 2,
  //   validations: {
  //     isRequired: true,
  //     default: [
  //       {
  //         validate: VALIDATION_METHODS.bool,
  //         getErrorMessage: VALIDATION_ERRORS.filled
  //       }
  //     ]
  //   }
  // },
  // 'TITOLARE_ESERCITA-ESERCITA_NO': {
  //   name: 'ESERCITA_NO',
  //   type: 'radio',
  //   cleanName: 'NO',
  //   position: 2,
  //   validations: {
  //     isRequired: true,
  //     default: [
  //       {
  //         validate: VALIDATION_METHODS.bool,
  //         getErrorMessage: VALIDATION_ERRORS.filled
  //       }
  //     ]
  //   }
  // },
  'RESIDENZA-FISCALE': {
    name: 'residenzaFiscale',
    type: 'selectbox',
    active: false,
    value: 'ITALIA',
    cleanName: 'Residenza Fiscale',
    options: {
      url: 'wgt/utils/nazionifromegon',
      mapping: { label: 'nome', value: 'nome' }
    }
  },
  'PRODUCT_PLUGIN-PLUGIN_TEMPLATE': {
    name: 'PLUGIN_TEMPLATE',
    text: 'PUNTO VENDITA',
    type: 'hidden',
    active: false,
    status: ['hidden'],
    trigger: [
      {
        type: 'call',
        fn: parsePersonalizzaWidgets,
        params: [
          {
            type: 'COMPONENT_PROP',
            name: 'rawValue'
          }
        ]
      }
    ]
  },
  'PRODUCT_PLUGIN-PLUGIN_VALIDATION_ERROR': {
    name: 'PLUGIN_VALIDATION_ERROR',
    text: 'PLUGIN_VALIDATION_ERROR',
    type: 'hidden',
    active: false,
    status: ['hidden']
  },
  
  'AZIENDA_SUBTYPE-FORMA_GIURIDIA': {
    name: 'FORMA_GIURIDIA',
    type: 'label',
    value:
      `<small><p>Società <b>finanziarie:</b> svolgono attività di concessione di crediti e microcrediti, concessione di finanziamenti, credito al consumo e credito ipotecario, l’emissione o gestione di carte di credito, di debito o di altri mezzi di pagamento etc…
      </p>
      <p>Società <b>non finanziarie:</b>  tutte le società di capitali, le società cooperative e le società di persone, le società semplici e le imprese individuali con oltre 5 dipendenti.
      </p></small>`,
  
      rawValue: null, 
      errorMessage: [],
      validations: [],
      status: [],
      extra: true,
      values: [],
      isSmall:true,
      active:true
    },
  
  'TITOLARE_EFFETTIVO-TITOLARE_EFFETTIVO_DATA': {
    name: 'TITOLARE_EFFETTIVO_DATA',
    value: '',
    active: false,
    status: [],
    errorMessage: [],
    validations: []
  }
}

export const getAddressStateComponents = (
  widgetName = 'RESIDENZA',
  addressId = ''
) => {
  const components = {}
  const NAZIONE = `${widgetName}-NAZIONE`
  const CAP = `${widgetName}-CAP`
  const PROVINCIA = `${widgetName}-PROVINCIA`
  const CITTA = `${widgetName}-CITTA`
  const INDIRIZZO = `${widgetName}-INDIRIZZO`
  components[NAZIONE] = {
    name: 'NAZIONE',
    type: 'text',
    isDisabled: true,
    value: 'ITALIA',
    cleanName: 'Nazione',
    addressId: addressId
    // type: 'selectbox',
    // cleanName: 'Nazione',
    // isDisabled: true,
    // position: 1,
    // options: {
    //   url: 'wgt/utils/nazionifromegon',
    //   mapping: { label: 'nome', value: 'nome' }
    // }
  }
  components[CAP] = {
    name: 'CAP',
    type: 'text',
    cleanName: 'CAP',
    autofill: {
      url: 'wgt/utils/dettaglicapfromegon',
      errorMessage: 'il CAP non è valido',
      mapping: [
        {
          key: 'capCode',
          componentId: CAP
        },
        {
          key: 'provincia',
          componentId: PROVINCIA
        },
        {
          key: 'localita',
          componentId: CITTA
        }
      ]
    },
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.cap,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    addressId: addressId
  }
  components[PROVINCIA] = {
    name: 'PROVINCIA',
    type: 'selectbox',
    cleanName: 'Provincia',
    isDisabled: true,
    options: {
      url: 'wgt/utils/province/VALID',
      mapping: { label: 'sigla', value: 'sigla' },
      fields: []
    },
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.alphabetic,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    notifyComponents: {
      validate: [INDIRIZZO]
    },
    addressId: addressId
  }
  let field = {}
  field[NAZIONE] = {
    fieldName: 'nome'
  }
  components[PROVINCIA].options.fields.push(field)

  components[CITTA] = {
    name: 'CITTA',
    type: 'text',
    isDisabled: true,
    cleanName: 'Città',
    options: {
      // url: 'wgt/utils/comunifromegon',
      mapping: { label: 'localita', value: 'localita' },
      fields: []
    },
    autofill: {
      mapping: [
        {
          key: 'localita',
          resKey: 'provincia',
          componentId: PROVINCIA
        }
      ]
    },
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.city,
          getErrorMessage: VALIDATION_ERRORS.filled
        }
      ]
    },
    notifyComponents: {
      validate: [INDIRIZZO]
    },
    addressId: addressId
  }
  field = {}
  field[PROVINCIA] = {
    fieldName: 'provincia'
  }
  components[CITTA].options.fields.push(field)

  components[INDIRIZZO] = {
    name: 'INDIRIZZO',
    type: 'text',
    cleanName: 'Indirizzo e numero civico',
    modalTitle: "Verifica l'indirizzo di residenza",
    validations: {
      isRequired: true,
      default: [
        {
          validate: VALIDATION_METHODS.address,
          getErrorMessage: VALIDATION_ERRORS.address
        }
      ]
    },
    hint: {
      value: HINTS.address,
      visible: false
    },
    addressId: addressId
  }
  return components
}

export const RefIdMap = {}
export const LinkIdMap = {}

export const getResumeByOtpMock = (body, guid) => ({
  status: 'success',
  message: 'The request is successfully served.',
  step: {
    number: null,
    last: false,
    contactId: null,
    name: 'resume-otp',
    widgets: [
      {
        code: '-223',
        name: 'LABEL',
        bundleLink: null,
        bundleCode: null,
        position: null,
        components: [
          {
            name: 'LABEL',
            value: 'ACCEDI ALLA TUA RICHIESTA',
            active: true,
            status: [],
            errorMessage: [],
            validations: [],
            values: [],
            type: null
          },
          {
            name: 'SUB_LABEL',
            value:
              "Richiedi l'invio del codice che ricevi via SMS per accedere e visualizzare la richiesta.",
            active: true,
            status: [],
            errorMessage: [],
            validations: [],
            values: [],
            type: null
          }
        ],
        status: [],
        errorMessage: []
      },
      {
        code: '-224',
        name: 'RESUME_BY_CELL',
        bundleLink: null,
        bundleCode: null,
        position: null,
        components: [
          {
            name: 'PREF_CELLULARE',
            value: '+39',
            active: true,
            status: ['readonly'],
            errorMessage: [],
            validations: ['number'],
            values: [],
            type: null
          },
          {
            name: 'NUM_CELLULARE',
            value: body.numCell,
            active: true,
            status: ['readonly'],
            errorMessage: [],
            validations: ['number'],
            values: [],
            type: null
          },
          {
            name: 'CODICE_CELLULARE',
            value: '',
            active: true,
            status: [],
            errorMessage: [],
            validations: ['alphanumeric'],
            values: [],
            type: null
          },
          {
            name: 'GUID_PROCESSO',
            value: guid,
            active: true,
            status: ['readonly'],
            errorMessage: [],
            validations: [],
            values: [],
            type: null
          }
        ],
        status: [],
        errorMessage: []
      }
    ]
  }
})

export const getThankYouPageMock = (contactId, parentGuid) => ({
  status: 'success',
  message: 'The request is successfully served.',
  step: {
    number: 6,
    last: true,
    name: 'thanks',
    contactId: contactId,
    widgets: [
      {
        code: '1337',
        name: 'THANKS',
        bundleLink: null,
        bundleCode: null,
        position: null,
        components: [
          {
            name: 'LABEL',
            value: 'Thanks',
            active: true,
            status: [],
            errorMessage: [],
            validations: [],
            values: [],
            type: 'hidden'
          },
          !!parentGuid && {
            name: 'RESUME_INTEST_2',
            value: parentGuid,
            active: true,
            status: [],
            errorMessage: [],
            validations: [],
            values: [],
            type: 'hidden'
          }
        ],
        status: [],
        errorMessage: []
      }
    ]
  }
})

export const getReuploadDocumentsMock = (docType, showSelfie) => {
  const mock = {
    status: 'success',
    message: 'Next step successfully retreived',
    step: {
      number: null,
      last: false,
      contactId: 'null',
      name: 'reupload',
      widgets: [
        {
          code: '1934',
          name: 'DOCUMENTO',
          bundleLink: null,
          bundleCode: null,
          position: 2,
          components: [
            {
              name: 'TIPO_DOCUMENTO',
              value: docType,
              active: true,
              status: ['hidden'],
              errorMessage: [],
              validations: ['required'],
              values: [],
              type: 'selectbox'
            },
            {
              name: 'DOCF_UPLOAD',
              value: '',
              active: true,
              status: [],
              errorMessage: [],
              validations: ['required'],
              values: [],
              type: null
            },
            {
              name: 'DOCR_UPLOAD',
              value: '',
              active: true,
              status: [],
              errorMessage: [],
              validations: ['required'],
              values: [],
              type: null
            }
          ],
          status: [],
          errorMessage: []
        },
        {
          code: '1937',
          name: 'ATTESA',
          bundleLink: null,
          bundleCode: null,
          position: 5,
          components: [],
          status: ['hidden'],
          errorMessage: []
        }
      ]
    }
  }

  if (showSelfie) {
    const selfieWidget = {
      code: '1370',
      name: 'SELFIE',
      bundleLink: null,
      bundleCode: null,
      position: 1,
      components: [
        {
          name: 'SELFIE_UPLOAD',
          value: '',
          active: true,
          status: [],
          errorMessage: [],
          validations: ['required'],
          values: [],
          type: null
        }
      ],
      status: [],
      errorMessage: []
    }

    mock.step.widgets.unshift(selfieWidget)
  }

  return mock
}
//export const TITOLARE_LIST = []
export const savePG = {}



// WEBPACK FOOTER //
// ./state/stateExtension.js